import type { Product, HeroSlide } from "@/types";
import { getSeller } from "./sellers";

export const products: Product[] = [
  // ── UrbanEdge (s1) - Streetwear-adjacent shoes and apparel for men ──
  {
    id: "1",
    name: "Cloud Runner",
    slug: "cloud-runner",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "new-arrivals", "best-sellers", "all"],
    price: 479,
    type: "runner",
    material: "mesh",
    rating: 4.7,
    reviewCount: 312,
    tags: ["breathable", "lightweight", "machine-washable"],
    sellerId: "s1",
    colors: [
      { name: "Jet Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
      { name: "Stone White", hex: "#f0ede6", image: "/images/products/product-9.jpg" },
      { name: "Olive", hex: "#5c6b4f", image: "/images/products/product-3.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "A lightweight everyday runner with a breathable knit upper and cushioned sole. Built for comfort from morning to night.",
    features: ["Breathable mesh upper", "Cushioned insole", "Lightweight EVA midsole", "Natural rubber outsole"],
    materials: "Upper: Recycled polyester mesh. Midsole: Sugarcane-based EVA. Outsole: Natural rubber.",
    care: "Remove insoles and laces. Machine wash cold on gentle cycle. Air dry.",
    badge: "bestseller",
    images: [
      "/images/products/product-1.jpg",
      "/images/products/product-10.jpg",
      "/images/products/product-9.jpg",
    ],
  },
  {
    id: "3",
    name: "Trail Pacer",
    slug: "trail-pacer",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "new-arrivals", "all"],
    price: 559,
    type: "hiker",
    material: "wool",
    rating: 4.5,
    reviewCount: 178,
    tags: ["water-resistant", "trail-ready", "durable", "grippy"],
    sellerId: "s1",
    colors: [
      { name: "Forest Green", hex: "#3d5a3d", image: "/images/products/product-3.jpg" },
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-7.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "Rugged enough for the trail, comfortable enough for all day. Grippy outsole meets cloud-like cushioning.",
    features: ["Reinforced toe cap", "All-terrain outsole", "Water-resistant upper", "Padded ankle collar"],
    materials: "Upper: Merino wool blend. Midsole: Bio-based foam. Outsole: Recycled rubber.",
    care: "Spot clean with mild soap. Air dry away from direct heat.",
    badge: "new",
    images: [
      "/images/products/product-3.jpg",
      "/images/products/product-7.jpg",
    ],
  },
  {
    id: "9",
    name: "Dash Sport",
    slug: "dash-sport",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "new-arrivals", "all"],
    price: 579,
    type: "trainer",
    material: "mesh",
    rating: 4.3,
    reviewCount: 156,
    tags: ["responsive", "reflective", "performance", "breathable"],
    sellerId: "s1",
    colors: [
      { name: "Storm Blue", hex: "#4a6fa5", image: "/images/products/product-6.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "Engineered for performance. Responsive cushioning and a breathable upper for your best run yet.",
    features: ["Responsive foam midsole", "Breathable mesh", "Reflective details", "Flexible outsole"],
    materials: "Upper: Recycled mesh. Midsole: Bio-foam. Outsole: Carbon rubber.",
    care: "Spot clean. Air dry. Do not machine wash.",
    badge: "new",
    images: [
      "/images/products/product-6.jpg",
      "/images/products/product-5.jpg",
      "/images/products/product-1.jpg",
    ],
  },
  {
    id: "12",
    name: "Summit Hiker",
    slug: "summit-hiker",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 639,
    type: "hiker",
    material: "wool",
    rating: 4.8,
    reviewCount: 98,
    tags: ["waterproof", "warm", "trail-ready", "durable"],
    sellerId: "s1",
    colors: [
      { name: "Earth Brown", hex: "#6b5b4a", image: "/images/products/product-14.jpg" },
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-7.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "Built for the outdoors but comfortable enough for everyday. Waterproof and warm.",
    features: ["Waterproof membrane", "Merino wool lining", "Vibram outsole", "Padded collar"],
    materials: "Upper: Merino wool with waterproof membrane. Outsole: Vibram rubber.",
    care: "Clean with brush and mild soap. Reproof periodically.",
    images: [
      "/images/products/product-14.jpg",
      "/images/products/product-4.jpg",
      "/images/products/product-7.jpg",
    ],
  },
  {
    id: "25",
    name: "Pullover Hoodie",
    slug: "pullover-hoodie-mens",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 389,
    type: "hoodie",
    material: "wool",
    rating: 4.8,
    reviewCount: 112,
    tags: ["cozy", "warm", "layering", "sustainable"],
    sellerId: "s1",
    colors: [
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-20.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-21.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "A cozy merino wool hoodie that regulates temperature naturally. Warm without the bulk.",
    features: ["Merino wool terry", "Kangaroo pocket", "Ribbed cuffs", "Adjustable hood"],
    materials: "80% Merino wool, 20% nylon.",
    care: "Machine wash cold gentle cycle. Lay flat to dry.",
    images: ["/images/products/product-20.jpg", "/images/products/product-21.jpg"],
  },
  {
    id: "27",
    name: "Jogger Pant",
    slug: "jogger-pant-mens",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 349,
    type: "pant",
    material: "knit",
    rating: 4.5,
    reviewCount: 95,
    tags: ["comfortable", "tapered", "casual", "stretchy"],
    sellerId: "s1",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-24.jpg" },
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-25.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Tapered joggers with a soft knit fabric that moves with you. Refined enough for the coffee shop.",
    features: ["Knit terry fabric", "Elastic waist with drawcord", "Tapered leg", "Side pockets"],
    materials: "65% Organic cotton, 30% recycled polyester, 5% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    images: ["/images/products/product-24.jpg", "/images/products/product-25.jpg"],
  },
  {
    id: "29",
    name: "Lightweight Jacket",
    slug: "lightweight-jacket-mens",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "new-arrivals", "all"],
    price: 509,
    type: "jacket",
    material: "mesh",
    rating: 4.4,
    reviewCount: 67,
    tags: ["lightweight", "windproof", "packable", "layering"],
    sellerId: "s1",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-22.jpg" },
      { name: "Olive", hex: "#5c6b4f", image: "/images/products/product-23.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "A windproof jacket that packs into its own pocket. Light enough to carry everywhere.",
    features: ["Recycled mesh lining", "Windproof shell", "Packable design", "Adjustable hood"],
    materials: "Shell: Recycled nylon. Lining: Recycled mesh.",
    care: "Machine wash cold. Hang dry.",
    badge: "new",
    images: ["/images/products/product-22.jpg", "/images/products/product-23.jpg"],
  },
  {
    id: "35",
    name: "Street Runner X",
    slug: "street-runner-x",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "new-arrivals", "all"],
    price: 499,
    type: "runner",
    material: "mesh",
    rating: 4.6,
    reviewCount: 84,
    tags: ["street-style", "cushioned", "bold", "lightweight"],
    sellerId: "s1",
    colors: [
      { name: "Triple Black", hex: "#0a0a0a", image: "/images/products/product-1.jpg" },
      { name: "Off White", hex: "#f5f0eb", image: "/images/products/product-9.jpg" },
      { name: "Storm Grey", hex: "#6b7280", image: "/images/products/product-8.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "Street-level aesthetics meet next-gen cushioning. The X takes the Cloud Runner silhouette and drops it into the urban landscape with a heavier outsole and bolder colorways.",
    features: ["Heavy-duty rubber outsole", "Breathable mesh upper", "Extra cushioned midsole", "Reinforced heel counter"],
    materials: "Upper: Recycled polyester mesh. Midsole: Dual-density EVA. Outsole: Carbon rubber.",
    care: "Remove insoles and laces. Machine wash cold on gentle cycle. Air dry.",
    badge: "new",
    images: [
      "/images/products/product-1.jpg",
      "/images/products/product-9.jpg",
      "/images/products/product-8.jpg",
      "/images/products/product-10.jpg",
    ],
  },
  {
    id: "36",
    name: "Stealth Hoodie",
    slug: "stealth-hoodie",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "new-arrivals", "all"],
    price: 429,
    type: "hoodie",
    material: "knit",
    rating: 4.5,
    reviewCount: 63,
    tags: ["streetwear", "oversized", "warm", "layering"],
    sellerId: "s1",
    colors: [
      { name: "Washed Black", hex: "#2a2a2a", image: "/images/products/product-20.jpg" },
      { name: "Olive", hex: "#5c6b4f", image: "/images/products/product-21.jpg" },
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-20.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Heavyweight oversized hoodie with dropped shoulders and a boxy cut. The kind of piece that anchors your whole fit. Double-layered hood, hidden side zip pockets, ribbed cuffs that actually stay put.",
    features: ["Oversized boxy fit", "Double-layered hood", "Hidden side zip pockets", "Heavyweight 380gsm knit"],
    materials: "80% Organic cotton, 20% recycled polyester. 380gsm brushed fleece.",
    care: "Machine wash cold inside out. Hang dry.",
    badge: "new",
    images: [
      "/images/products/product-20.jpg",
      "/images/products/product-21.jpg",
      "/images/products/product-20.jpg",
      "/images/products/product-21.jpg",
    ],
  },
  {
    id: "37",
    name: "Cargo Jogger",
    slug: "cargo-jogger",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 399,
    type: "pant",
    material: "knit",
    rating: 4.4,
    reviewCount: 47,
    tags: ["streetwear", "cargo", "tapered", "utility"],
    sellerId: "s1",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-24.jpg" },
      { name: "Olive", hex: "#5c6b4f", image: "/images/products/product-25.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Tapered cargo joggers with oversized utility pockets and a drawcord waist. Streetwear utility meets everyday comfort in a heavyweight cotton-poly blend.",
    features: ["Cargo pockets with flap", "Tapered leg with elastic cuff", "Drawcord waist", "Heavyweight fabric"],
    materials: "70% Cotton, 25% recycled polyester, 5% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    images: [
      "/images/products/product-24.jpg",
      "/images/products/product-25.jpg",
      "/images/products/product-24.jpg",
      "/images/products/product-25.jpg",
    ],
  },
  {
    id: "38",
    name: "Nightfall Runner",
    slug: "nightfall-runner",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 529,
    type: "runner",
    material: "mesh",
    rating: 4.3,
    reviewCount: 39,
    tags: ["reflective", "night-running", "cushioned", "bold"],
    sellerId: "s1",
    colors: [
      { name: "Shadow Black", hex: "#111111", image: "/images/products/product-1.jpg" },
      { name: "Neon Accent", hex: "#c4ff00", image: "/images/products/product-6.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "Full reflective detailing on a blacked-out runner. Visibility meets attitude for after-dark sessions and early mornings.",
    features: ["360-degree reflective hits", "Cushioned EVA midsole", "Breathable mesh upper", "Rubber outsole"],
    materials: "Upper: Recycled mesh with reflective overlays. Midsole: EVA. Outsole: Rubber.",
    care: "Spot clean. Air dry.",
    images: [
      "/images/products/product-1.jpg",
      "/images/products/product-6.jpg",
      "/images/products/product-10.jpg",
      "/images/products/product-16.jpg",
    ],
  },
  {
    id: "39",
    name: "Utility Jacket",
    slug: "utility-jacket",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 599,
    type: "jacket",
    material: "mesh",
    rating: 4.7,
    reviewCount: 28,
    tags: ["streetwear", "utility", "windproof", "layering"],
    sellerId: "s1",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-22.jpg" },
      { name: "Army Green", hex: "#4a5a3a", image: "/images/products/product-23.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Military-inspired utility jacket with a modern streetwear cut. Multiple pockets, adjustable waist cinch, and a water-resistant shell that handles city weather.",
    features: ["Water-resistant shell", "4 utility pockets", "Adjustable waist cinch", "Mesh lined"],
    materials: "Shell: Recycled nylon. Lining: Recycled mesh. DWR finish.",
    care: "Machine wash cold. Hang dry. Reproof as needed.",
    images: [
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
    ],
  },
  {
    id: "40",
    name: "Urban Slide",
    slug: "urban-slide",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 219,
    type: "slide",
    material: "tree-fiber",
    rating: 4.1,
    reviewCount: 52,
    tags: ["easy-on", "casual", "lightweight"],
    sellerId: "s1",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-16.jpg" },
      { name: "Olive", hex: "#5c6b4f", image: "/images/products/product-8.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12],
    description:
      "Chunky-sole slide for post-gym or lazy weekends. Contoured footbed with extra arch support. The kind of slide you actually want to be seen in.",
    features: ["Contoured footbed", "Chunky platform sole", "Quick-dry strap", "Arch support"],
    materials: "Strap: Recycled nylon. Sole: Sugarcane EVA.",
    care: "Rinse with water. Air dry.",
    images: [
      "/images/products/product-16.jpg",
      "/images/products/product-8.jpg",
      "/images/products/product-1.jpg",
      "/images/products/product-10.jpg",
    ],
  },
  {
    id: "41",
    name: "Block Tee",
    slug: "block-tee",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 199,
    type: "tee",
    material: "tree-fiber",
    rating: 4.3,
    reviewCount: 71,
    tags: ["streetwear", "oversized", "bold", "everyday"],
    sellerId: "s1",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-17.jpg" },
      { name: "White", hex: "#f0ede6", image: "/images/products/product-18.jpg" },
      { name: "Grey", hex: "#8a8a8a", image: "/images/products/product-19.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Heavyweight boxy tee with a dropped shoulder. Clean block fit, no logos, no noise - just good fabric and a silhouette that works with everything.",
    features: ["Boxy oversized fit", "Dropped shoulders", "Reinforced collar", "250gsm weight"],
    materials: "100% Organic cotton, 250gsm.",
    care: "Machine wash cold. Tumble dry low.",
    images: [
      "/images/products/product-17.jpg",
      "/images/products/product-18.jpg",
      "/images/products/product-19.jpg",
      "/images/products/product-17.jpg",
    ],
  },
  {
    id: "42",
    name: "Drift Trainer",
    slug: "drift-trainer",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "best-sellers", "all"],
    price: 459,
    type: "trainer",
    material: "mesh",
    rating: 4.6,
    reviewCount: 123,
    tags: ["versatile", "cushioned", "daily-wear", "modern"],
    sellerId: "s1",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
      { name: "Stone", hex: "#c4b59a", image: "/images/products/product-8.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-6.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "The do-everything trainer. From the gym floor to the bar stool - responsive cushioning wrapped in a clean, minimal upper that doesn't try too hard.",
    features: ["Responsive foam midsole", "Minimal mesh upper", "Rubber outsole", "Padded collar"],
    materials: "Upper: Recycled mesh. Midsole: Bio-foam. Outsole: Rubber.",
    care: "Spot clean. Air dry.",
    images: [
      "/images/products/product-1.jpg",
      "/images/products/product-8.jpg",
      "/images/products/product-6.jpg",
      "/images/products/product-10.jpg",
    ],
  },
  {
    id: "43",
    name: "Edge Runner Pro",
    slug: "edge-runner-pro",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "new-arrivals", "all"],
    price: 549,
    type: "runner",
    material: "knit",
    rating: 4.5,
    reviewCount: 31,
    tags: ["knit", "premium", "cushioned", "street"],
    sellerId: "s1",
    colors: [
      { name: "Cement", hex: "#8a8a8a", image: "/images/products/product-8.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "Full-knit runner with a sock-like collar and a stacked midsole. Built for the streets, not the track. Premium materials, premium comfort, zero compromise.",
    features: ["Full-knit upper", "Sock-like collar", "Stacked EVA midsole", "Rubber outsole"],
    materials: "Upper: Recycled knit. Midsole: Dual-density EVA. Outsole: Natural rubber.",
    care: "Remove insoles and laces. Machine wash cold. Air dry.",
    badge: "new",
    images: [
      "/images/products/product-8.jpg",
      "/images/products/product-1.jpg",
      "/images/products/product-10.jpg",
      "/images/products/product-6.jpg",
    ],
  },
  {
    id: "44",
    name: "Windbreaker Pullover",
    slug: "windbreaker-pullover",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 449,
    type: "jacket",
    material: "mesh",
    rating: 4.2,
    reviewCount: 22,
    tags: ["streetwear", "windproof", "half-zip", "layering"],
    sellerId: "s1",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-22.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-23.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Half-zip windbreaker with a kangaroo pocket and mesh lining. Packs flat, blocks wind, looks good doing both.",
    features: ["Half-zip front", "Kangaroo pocket", "Windproof shell", "Mesh lined"],
    materials: "Shell: Recycled nylon. Lining: Recycled mesh.",
    care: "Machine wash cold. Hang dry.",
    images: [
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
    ],
  },
  {
    id: "45",
    name: "Grip Hiker Low",
    slug: "grip-hiker-low",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 489,
    type: "hiker",
    material: "leather",
    rating: 4.4,
    reviewCount: 18,
    tags: ["trail", "low-cut", "grippy", "durable"],
    sellerId: "s1",
    colors: [
      { name: "Earth", hex: "#6b5b4a", image: "/images/products/product-14.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-7.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "Low-cut hiker with a leather upper and aggressive lug sole. Trail-ready with a profile clean enough for the city.",
    features: ["Leather upper", "Lug outsole", "Padded collar", "EVA midsole"],
    materials: "Upper: Full-grain leather. Midsole: EVA. Outsole: Rubber lug.",
    care: "Clean with brush. Condition leather periodically.",
    images: [
      "/images/products/product-14.jpg",
      "/images/products/product-7.jpg",
      "/images/products/product-4.jpg",
      "/images/products/product-3.jpg",
    ],
  },
  {
    id: "46",
    name: "Raw Tee",
    slug: "raw-tee",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 249,
    type: "tee",
    material: "tree-fiber",
    rating: 4.2,
    reviewCount: 34,
    tags: ["raw-edge", "relaxed", "minimal", "everyday"],
    sellerId: "s1",
    colors: [
      { name: "Washed Black", hex: "#2a2a2a", image: "/images/products/product-17.jpg" },
      { name: "Sand", hex: "#c4b59a", image: "/images/products/product-18.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Raw-edge tee with a relaxed, slightly cropped fit. Enzyme-washed for a broken-in feel from day one.",
    features: ["Raw-edge hem and sleeves", "Enzyme-washed", "Relaxed fit", "200gsm weight"],
    materials: "100% Eucalyptus tree fiber.",
    care: "Machine wash cold. Air dry.",
    images: [
      "/images/products/product-17.jpg",
      "/images/products/product-18.jpg",
      "/images/products/product-19.jpg",
      "/images/products/product-17.jpg",
    ],
  },
  {
    id: "104",
    name: "Shadow Trainer",
    slug: "shadow-trainer",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 439,
    type: "trainer",
    material: "mesh",
    rating: 4.3,
    reviewCount: 26,
    tags: ["tonal", "clean", "versatile", "everyday"],
    sellerId: "s1",
    colors: [
      { name: "Shadow", hex: "#2a2a2a", image: "/images/products/product-1.jpg" },
      { name: "Fog", hex: "#c4c4c4", image: "/images/products/product-8.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "All-tonal trainer with a matte finish. The opposite of loud - it just quietly makes every outfit better.",
    features: ["Tonal colorway", "Matte finish", "EVA midsole", "Rubber outsole"],
    materials: "Upper: Recycled mesh. Midsole: EVA. Outsole: Rubber.",
    care: "Spot clean. Air dry.",
    images: [
      "/images/products/product-1.jpg",
      "/images/products/product-8.jpg",
      "/images/products/product-10.jpg",
      "/images/products/product-7.jpg",
    ],
  },
  {
    id: "105",
    name: "Track Pant",
    slug: "track-pant-mens",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 379,
    type: "pant",
    material: "knit",
    rating: 4.4,
    reviewCount: 38,
    tags: ["streetwear", "track", "side-stripe", "tapered"],
    sellerId: "s1",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-24.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-25.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Track pants with a tonal side stripe and tapered fit. Zip pockets, elastic cuff. The kind of track pant you wear out, not just to the gym.",
    features: ["Tonal side stripe", "Zip pockets", "Elastic cuff", "Tapered leg"],
    materials: "75% Cotton, 25% recycled polyester.",
    care: "Machine wash cold. Tumble dry low.",
    images: [
      "/images/products/product-24.jpg",
      "/images/products/product-25.jpg",
      "/images/products/product-24.jpg",
      "/images/products/product-25.jpg",
    ],
  },
  {
    id: "106",
    name: "Heavyweight Crewneck",
    slug: "heavyweight-crewneck",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "new-arrivals", "all"],
    price: 369,
    type: "hoodie",
    material: "knit",
    rating: 4.5,
    reviewCount: 17,
    tags: ["streetwear", "heavyweight", "crewneck", "oversized"],
    sellerId: "s1",
    colors: [
      { name: "Washed Black", hex: "#2a2a2a", image: "/images/products/product-20.jpg" },
      { name: "Cream", hex: "#f0ede6", image: "/images/products/product-21.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "420gsm heavyweight crewneck with a boxy cut. No hood, no zip, no logo - just a solid piece of knitwear that'll last years.",
    features: ["420gsm heavyweight", "Boxy fit", "Ribbed cuffs and hem", "Dropped shoulders"],
    materials: "80% Organic cotton, 20% recycled polyester.",
    care: "Machine wash cold inside out. Hang dry.",
    badge: "new",
    images: [
      "/images/products/product-20.jpg",
      "/images/products/product-21.jpg",
      "/images/products/product-20.jpg",
      "/images/products/product-21.jpg",
    ],
  },
  {
    id: "107",
    name: "Mesh Runner Low",
    slug: "mesh-runner-low",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 419,
    type: "runner",
    material: "mesh",
    rating: 4.2,
    reviewCount: 14,
    tags: ["low-profile", "breathable", "minimal", "summer"],
    sellerId: "s1",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-9.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12],
    description:
      "Low-profile mesh runner with a thin sole and minimal upper. For when you want to feel the ground under you.",
    features: ["Low-profile sole", "Full mesh upper", "Minimal padding", "Lightweight"],
    materials: "Upper: Recycled mesh. Midsole: Thin EVA. Outsole: Rubber.",
    care: "Machine wash cold. Air dry.",
    images: [
      "/images/products/product-9.jpg",
      "/images/products/product-1.jpg",
      "/images/products/product-10.jpg",
      "/images/products/product-8.jpg",
    ],
  },
  {
    id: "108",
    name: "Tech Vest",
    slug: "tech-vest",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 359,
    type: "jacket",
    material: "mesh",
    rating: 4.1,
    reviewCount: 9,
    tags: ["streetwear", "vest", "layering", "utility"],
    sellerId: "s1",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-22.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Padded vest with a matte shell and zip pockets. Layer it over a hoodie or wear it solo. Technical streetwear done right.",
    features: ["Padded insulation", "Matte shell", "Zip pockets", "Stand collar"],
    materials: "Shell: Recycled nylon. Fill: Recycled polyester insulation.",
    care: "Machine wash cold. Tumble dry low.",
    images: [
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
    ],
  },
  {
    id: "109",
    name: "Knit Shorts",
    slug: "knit-shorts-mens",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 249,
    type: "pant",
    material: "knit",
    rating: 4.3,
    reviewCount: 21,
    tags: ["streetwear", "shorts", "summer", "casual"],
    sellerId: "s1",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-24.jpg" },
      { name: "Olive", hex: "#5c6b4f", image: "/images/products/product-25.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "French terry shorts with a 7-inch inseam. Elastic waist, side pockets, clean lines. Summer staple.",
    features: ["French terry fabric", "7-inch inseam", "Elastic waist with drawcord", "Side pockets"],
    materials: "80% Cotton, 20% recycled polyester.",
    care: "Machine wash cold. Tumble dry low.",
    images: [
      "/images/products/product-24.jpg",
      "/images/products/product-25.jpg",
      "/images/products/product-24.jpg",
      "/images/products/product-25.jpg",
    ],
  },

  // ── Bella Donna (s2) - Women's shoes and apparel ──
  {
    id: "2",
    name: "Cloud Runner",
    slug: "cloud-runner-womens",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "new-arrivals", "best-sellers", "all"],
    price: 479,
    type: "runner",
    material: "mesh",
    rating: 4.8,
    reviewCount: 287,
    tags: ["breathable", "lightweight", "machine-washable"],
    sellerId: "s2",
    colors: [
      { name: "Blush Pink", hex: "#d4a5a5", image: "/images/products/product-12.jpg" },
      { name: "Stone White", hex: "#f0ede6", image: "/images/products/product-11.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-13.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10, 11],
    description:
      "A lightweight everyday runner with a breathable knit upper and cushioned sole. Built for comfort from morning to night.",
    features: ["Breathable mesh upper", "Cushioned insole", "Lightweight EVA midsole", "Natural rubber outsole"],
    materials: "Upper: Recycled polyester mesh. Midsole: Sugarcane-based EVA. Outsole: Natural rubber.",
    care: "Remove insoles and laces. Machine wash cold on gentle cycle. Air dry.",
    badge: "bestseller",
    images: [
      "/images/products/product-12.jpg",
      "/images/products/product-11.jpg",
      "/images/products/product-13.jpg",
    ],
  },
  {
    id: "4",
    name: "Breeze Slip-On",
    slug: "breeze-slip-on",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "best-sellers", "all"],
    price: 379,
    type: "slip-on",
    material: "tree-fiber",
    rating: 4.6,
    reviewCount: 421,
    tags: ["easy-on", "breathable", "machine-washable", "lightweight"],
    sellerId: "s2",
    colors: [
      { name: "Warm Sand", hex: "#c4b59a", image: "/images/products/product-15.jpg" },
      { name: "Jet Black", hex: "#1a1a1a", image: "/images/products/product-15.jpg" },
      { name: "Dusty Rose", hex: "#c49a9a", image: "/images/products/product-12.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description:
      "Slip into effortless style. A laceless design with a stretchy collar that hugs your foot just right.",
    features: ["Laceless entry", "Stretch collar", "Memory foam insole", "Lightweight construction"],
    materials: "Upper: Eucalyptus tree fiber. Midsole: Sugarcane EVA. Outsole: Natural rubber.",
    care: "Remove insoles. Machine wash cold on gentle cycle. Air dry.",
    badge: "bestseller",
    images: [
      "/images/products/product-15.jpg",
      "/images/products/product-12.jpg",
    ],
  },
  {
    id: "6",
    name: "Aero Knit",
    slug: "aero-knit",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "new-arrivals", "all"],
    price: 519,
    type: "runner",
    material: "knit",
    rating: 4.9,
    reviewCount: 203,
    tags: ["sock-like-fit", "ultra-light", "breathable", "machine-washable"],
    sellerId: "s2",
    colors: [
      { name: "Cloud White", hex: "#f5f0eb", image: "/images/products/product-2.jpg" },
      { name: "Coral", hex: "#e07a5f", image: "/images/products/product-5.jpg" },
      { name: "Deep Navy", hex: "#1e2d4a", image: "/images/products/product-13.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10, 11],
    description:
      "Featherlight and fully knitted for a sock-like fit. Your new go-to for everything.",
    features: ["One-piece knit upper", "Sock-like fit", "Ultra-light foam sole", "Removable insole"],
    materials: "Upper: Recycled knit. Midsole: Sugarcane EVA. Outsole: Natural rubber.",
    care: "Remove insoles and laces. Machine wash cold. Air dry.",
    badge: "new",
    images: [
      "/images/products/product-2.jpg",
      "/images/products/product-11.jpg",
      "/images/products/product-5.jpg",
    ],
  },
  {
    id: "11",
    name: "Glide Flat",
    slug: "glide-flat",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "best-sellers", "all"],
    price: 419,
    type: "flat",
    material: "tree-fiber",
    rating: 4.5,
    reviewCount: 267,
    tags: ["slip-on", "breathable", "machine-washable", "elegant"],
    sellerId: "s2",
    colors: [
      { name: "Jet Black", hex: "#1a1a1a", image: "/images/products/product-15.jpg" },
      { name: "Ballet Pink", hex: "#e8c4c4", image: "/images/products/product-12.jpg" },
      { name: "Forest", hex: "#3d5a3d", image: "/images/products/product-3.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description:
      "A sleek ballet flat with just enough support. Tree fiber keeps it cool and breathable all day.",
    features: ["Tree fiber upper", "Padded insole", "Flexible sole", "Slip-on design"],
    materials: "Upper: Eucalyptus tree fiber. Insole: Castor bean foam. Outsole: Natural rubber.",
    care: "Machine wash cold. Air dry.",
    badge: "bestseller",
    images: [
      "/images/products/product-15.jpg",
      "/images/products/product-12.jpg",
      "/images/products/product-3.jpg",
    ],
  },
  {
    id: "16",
    name: "Metro Step",
    slug: "metro-step",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "new-arrivals", "all"],
    price: 459,
    type: "walker",
    material: "knit",
    rating: 4.3,
    reviewCount: 47,
    tags: ["platform", "urban", "cushioned", "modern"],
    sellerId: "s2",
    colors: [
      { name: "Warm White", hex: "#f5efe6", image: "/images/products/product-2.jpg" },
      { name: "Burgundy", hex: "#6b2a3d", image: "/images/products/product-16.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description:
      "Urban style meets all-day comfort. A modern silhouette with a cushioned platform sole.",
    features: ["Platform sole", "Knit upper", "Padded tongue", "Cushioned insole"],
    materials: "Upper: Recycled knit. Midsole: Bio-based foam. Outsole: Rubber.",
    care: "Machine wash cold. Air dry.",
    badge: "new",
    images: [
      "/images/products/product-2.jpg",
      "/images/products/product-16.jpg",
    ],
  },
  {
    id: "26",
    name: "Pullover Hoodie",
    slug: "pullover-hoodie-womens",
    category: "women",
    productCategory: "apparel",
    collections: ["womens", "apparel", "all"],
    price: 389,
    type: "hoodie",
    material: "wool",
    rating: 4.7,
    reviewCount: 134,
    tags: ["cozy", "warm", "layering", "sustainable"],
    sellerId: "s2",
    colors: [
      { name: "Oatmeal", hex: "#c4b59a", image: "/images/products/product-20.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-21.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "A cozy merino wool hoodie that regulates temperature naturally. Warm without the bulk.",
    features: ["Merino wool terry", "Kangaroo pocket", "Ribbed cuffs", "Adjustable hood"],
    materials: "80% Merino wool, 20% nylon.",
    care: "Machine wash cold gentle cycle. Lay flat to dry.",
    images: ["/images/products/product-20.jpg", "/images/products/product-21.jpg"],
  },
  {
    id: "28",
    name: "Jogger Pant",
    slug: "jogger-pant-womens",
    category: "women",
    productCategory: "apparel",
    collections: ["womens", "apparel", "all"],
    price: 349,
    type: "pant",
    material: "knit",
    rating: 4.6,
    reviewCount: 108,
    tags: ["comfortable", "tapered", "casual", "stretchy"],
    sellerId: "s2",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-24.jpg" },
      { name: "Oatmeal", hex: "#c4b59a", image: "/images/products/product-25.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Tapered joggers with a soft knit fabric that moves with you. Refined enough for the coffee shop.",
    features: ["Knit terry fabric", "Elastic waist with drawcord", "Tapered leg", "Side pockets"],
    materials: "65% Organic cotton, 30% recycled polyester, 5% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    images: ["/images/products/product-24.jpg", "/images/products/product-25.jpg"],
  },
  {
    id: "30",
    name: "Cardigan",
    slug: "cardigan-womens",
    category: "women",
    productCategory: "apparel",
    collections: ["womens", "apparel", "new-arrivals", "all"],
    price: 429,
    type: "cardigan",
    material: "wool",
    rating: 4.8,
    reviewCount: 74,
    tags: ["cozy", "layering", "versatile", "soft"],
    sellerId: "s2",
    colors: [
      { name: "Oatmeal", hex: "#c4b59a", image: "/images/products/product-22.jpg" },
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-23.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "A relaxed-fit merino wool cardigan that layers effortlessly over anything.",
    features: ["Merino wool knit", "Relaxed fit", "Button front", "Ribbed cuffs and hem"],
    materials: "85% Merino wool, 15% nylon.",
    care: "Hand wash cold or machine wash gentle. Lay flat to dry.",
    badge: "new",
    images: ["/images/products/product-22.jpg", "/images/products/product-23.jpg"],
  },
  {
    id: "47",
    name: "Silk Touch Flat",
    slug: "silk-touch-flat",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "new-arrivals", "all"],
    price: 399,
    type: "flat",
    material: "tree-fiber",
    rating: 4.7,
    reviewCount: 89,
    tags: ["elegant", "lightweight", "cushioned", "office"],
    sellerId: "s2",
    colors: [
      { name: "Champagne", hex: "#e8d5b7", image: "/images/products/product-15.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-10.jpg" },
      { name: "Blush", hex: "#d4a5a5", image: "/images/products/product-12.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description:
      "Effortlessly refined flat with a pointed toe and cushioned footbed. The kind of shoe that elevates a simple outfit without trying. Silk-finish tree fiber upper with a barely-there weight that makes heels feel pointless.",
    features: ["Pointed toe", "Cushioned footbed", "Silk-finish upper", "Flexible sole"],
    materials: "Upper: Eucalyptus tree fiber with silk finish. Insole: Castor bean foam. Outsole: Natural rubber.",
    care: "Spot clean. Air dry.",
    badge: "new",
    images: [
      "/images/products/product-15.jpg",
      "/images/products/product-12.jpg",
      "/images/products/product-10.jpg",
      "/images/products/product-11.jpg",
    ],
  },
  {
    id: "48",
    name: "Wrap Dress",
    slug: "wrap-dress",
    category: "women",
    productCategory: "apparel",
    collections: ["womens", "apparel", "new-arrivals", "all"],
    price: 499,
    type: "cardigan",
    material: "tree-fiber",
    rating: 4.8,
    reviewCount: 56,
    tags: ["elegant", "versatile", "breathable", "office"],
    sellerId: "s2",
    colors: [
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-22.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-23.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "A true wrap silhouette in eucalyptus tree fiber that drapes beautifully and breathes all day. From the morning meeting to the evening out - one piece, every occasion.",
    features: ["True wrap design", "Self-tie belt", "V-neckline", "Knee length"],
    materials: "100% Eucalyptus tree fiber (TENCEL Lyocell).",
    care: "Machine wash cold gentle. Hang dry.",
    badge: "new",
    images: [
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
    ],
  },
  {
    id: "49",
    name: "Cloud Slip-On Ballet",
    slug: "cloud-slip-on-ballet",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "all"],
    price: 359,
    type: "slip-on",
    material: "knit",
    rating: 4.5,
    reviewCount: 142,
    tags: ["ballet", "cushioned", "lightweight", "versatile"],
    sellerId: "s2",
    colors: [
      { name: "Rose", hex: "#c49a9a", image: "/images/products/product-12.jpg" },
      { name: "Ivory", hex: "#f5f0eb", image: "/images/products/product-11.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-10.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description:
      "The comfort of a sneaker in a ballet silhouette. Full-knit upper with a cushioned sole that makes all-day wear effortless. A wardrobe essential.",
    features: ["Full-knit upper", "Cushioned EVA sole", "Flexible construction", "Slip-on entry"],
    materials: "Upper: Recycled knit. Sole: Sugarcane EVA. Outsole: Natural rubber.",
    care: "Machine wash cold. Air dry.",
    images: [
      "/images/products/product-12.jpg",
      "/images/products/product-11.jpg",
      "/images/products/product-10.jpg",
      "/images/products/product-15.jpg",
    ],
  },
  {
    id: "50",
    name: "Oversized Blazer",
    slug: "oversized-blazer",
    category: "women",
    productCategory: "apparel",
    collections: ["womens", "apparel", "all"],
    price: 549,
    type: "jacket",
    material: "wool",
    rating: 4.6,
    reviewCount: 37,
    tags: ["smart-casual", "oversized", "layering", "modern"],
    sellerId: "s2",
    colors: [
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-22.jpg" },
      { name: "Cream", hex: "#f0ede6", image: "/images/products/product-23.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Relaxed oversized blazer in a soft wool blend. Structured enough for meetings, relaxed enough for brunch. The single-button closure and patch pockets give it that effortless polish.",
    features: ["Oversized fit", "Single-button closure", "Patch pockets", "Fully lined"],
    materials: "Shell: 70% Wool, 30% recycled polyester. Lining: Recycled polyester.",
    care: "Dry clean recommended. Or machine wash cold gentle, lay flat to dry.",
    images: [
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
    ],
  },
  {
    id: "51",
    name: "Linen Tee",
    slug: "linen-tee-womens",
    category: "women",
    productCategory: "apparel",
    collections: ["womens", "apparel", "all"],
    price: 229,
    type: "tee",
    material: "tree-fiber",
    rating: 4.4,
    reviewCount: 98,
    tags: ["breathable", "relaxed", "summer", "everyday"],
    sellerId: "s2",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-17.jpg" },
      { name: "Sky Blue", hex: "#87CEEB", image: "/images/products/product-18.jpg" },
      { name: "Blush", hex: "#d4a5a5", image: "/images/products/product-19.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "A breezy linen-blend tee with a slightly cropped hem. The perfect summer layer - it gets softer with every wash.",
    features: ["Linen-blend fabric", "Slightly cropped hem", "Relaxed fit", "Pre-washed"],
    materials: "55% Linen, 45% organic cotton.",
    care: "Machine wash cold. Tumble dry low.",
    images: [
      "/images/products/product-17.jpg",
      "/images/products/product-18.jpg",
      "/images/products/product-19.jpg",
      "/images/products/product-17.jpg",
    ],
  },
  {
    id: "110",
    name: "Ankle Boot",
    slug: "ankle-boot-womens",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "new-arrivals", "all"],
    price: 549,
    type: "hiker",
    material: "leather",
    rating: 4.6,
    reviewCount: 43,
    tags: ["elegant", "leather", "ankle-boot", "versatile"],
    sellerId: "s2",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-10.jpg" },
      { name: "Cognac", hex: "#8b4513", image: "/images/products/product-14.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description:
      "Refined ankle boot in buttery-soft leather with a low block heel. The kind of boot that carries you from morning coffee to evening drinks without a wardrobe change. Cushioned insole for all-day wear.",
    features: ["Soft leather upper", "Block heel", "Cushioned insole", "Side zip"],
    materials: "Upper: Full-grain leather. Sole: Leather with rubber grip. Lining: Leather.",
    care: "Condition leather regularly. Store with shoe trees.",
    badge: "new",
    images: [
      "/images/products/product-10.jpg",
      "/images/products/product-14.jpg",
      "/images/products/product-15.jpg",
      "/images/products/product-7.jpg",
    ],
  },
  {
    id: "111",
    name: "Knit Loafer",
    slug: "knit-loafer-womens",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "all"],
    price: 389,
    type: "loafer",
    material: "knit",
    rating: 4.5,
    reviewCount: 67,
    tags: ["elegant", "knit", "comfortable", "office"],
    sellerId: "s2",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-10.jpg" },
      { name: "Taupe", hex: "#8b7d6b", image: "/images/products/product-15.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-13.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description:
      "Full-knit loafer that feels like a slipper but looks like you have your life together. The square toe and structured silhouette elevate any outfit.",
    features: ["Full-knit upper", "Square toe", "Cushioned insole", "Flexible sole"],
    materials: "Upper: Recycled knit. Insole: Memory foam. Outsole: Natural rubber.",
    care: "Machine wash cold. Air dry.",
    images: [
      "/images/products/product-10.jpg",
      "/images/products/product-15.jpg",
      "/images/products/product-13.jpg",
      "/images/products/product-11.jpg",
    ],
  },
  {
    id: "112",
    name: "Cropped Jacket",
    slug: "cropped-jacket-womens",
    category: "women",
    productCategory: "apparel",
    collections: ["womens", "apparel", "all"],
    price: 499,
    type: "jacket",
    material: "wool",
    rating: 4.7,
    reviewCount: 29,
    tags: ["elegant", "cropped", "layering", "modern"],
    sellerId: "s2",
    colors: [
      { name: "Cream", hex: "#f0ede6", image: "/images/products/product-22.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-23.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Cropped wool-blend jacket with a collarless neckline and raw-edge trim. The piece that makes jeans and a tee look intentional. Unlined for a lightweight feel.",
    features: ["Cropped length", "Collarless neckline", "Raw-edge trim", "Open front"],
    materials: "Shell: 70% Wool, 30% recycled polyester.",
    care: "Dry clean or hand wash cold. Lay flat to dry.",
    images: [
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
    ],
  },
  {
    id: "113",
    name: "Silk Cami",
    slug: "silk-cami",
    category: "women",
    productCategory: "apparel",
    collections: ["womens", "apparel", "new-arrivals", "all"],
    price: 299,
    type: "tee",
    material: "tree-fiber",
    rating: 4.8,
    reviewCount: 51,
    tags: ["elegant", "camisole", "layering", "summer"],
    sellerId: "s2",
    colors: [
      { name: "Champagne", hex: "#e8d5b7", image: "/images/products/product-17.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-18.jpg" },
      { name: "Ivory", hex: "#f5f0eb", image: "/images/products/product-19.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Silk-finish camisole with adjustable straps and a cowl neckline. Layer it under a blazer or let it do the talking on its own. The drape is everything.",
    features: ["Cowl neckline", "Adjustable straps", "Silk finish", "Relaxed fit"],
    materials: "100% Eucalyptus tree fiber with silk-finish treatment.",
    care: "Hand wash cold. Hang dry.",
    badge: "new",
    images: [
      "/images/products/product-17.jpg",
      "/images/products/product-18.jpg",
      "/images/products/product-19.jpg",
      "/images/products/product-17.jpg",
    ],
  },
  {
    id: "114",
    name: "Wide Leg Pant",
    slug: "wide-leg-pant-womens",
    category: "women",
    productCategory: "apparel",
    collections: ["womens", "apparel", "all"],
    price: 429,
    type: "pant",
    material: "tree-fiber",
    rating: 4.6,
    reviewCount: 34,
    tags: ["elegant", "wide-leg", "office", "versatile"],
    sellerId: "s2",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-24.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-25.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "High-waisted wide-leg trousers in a flowing tree-fiber fabric. The silhouette of tailored trousers with the comfort of pajamas. A wardrobe anchor.",
    features: ["High waist", "Wide leg", "Side zip", "Pressed crease"],
    materials: "100% Eucalyptus tree fiber (TENCEL Lyocell).",
    care: "Machine wash cold gentle. Hang dry. Iron on low.",
    images: [
      "/images/products/product-24.jpg",
      "/images/products/product-25.jpg",
      "/images/products/product-24.jpg",
      "/images/products/product-25.jpg",
    ],
  },
  {
    id: "115",
    name: "Platform Slip-On",
    slug: "platform-slip-on-womens",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "all"],
    price: 439,
    type: "slip-on",
    material: "knit",
    rating: 4.4,
    reviewCount: 21,
    tags: ["platform", "modern", "cushioned", "statement"],
    sellerId: "s2",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-2.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-10.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description:
      "Platform slip-on with a sculpted sole and full-knit upper. Adds height without the heel. Statement piece with sneaker-level comfort.",
    features: ["Sculpted platform sole", "Full-knit upper", "Elastic gusset", "Cushioned insole"],
    materials: "Upper: Recycled knit. Midsole: EVA platform. Outsole: Rubber.",
    care: "Machine wash cold. Air dry.",
    images: [
      "/images/products/product-2.jpg",
      "/images/products/product-10.jpg",
      "/images/products/product-11.jpg",
      "/images/products/product-12.jpg",
    ],
  },
  {
    id: "116",
    name: "Wool Scarf",
    slug: "wool-scarf-womens",
    category: "women",
    productCategory: "accessories",
    collections: ["womens", "accessories", "all"],
    price: 249,
    type: "beanie",
    material: "wool",
    rating: 4.7,
    reviewCount: 18,
    tags: ["elegant", "warm", "winter", "layering"],
    sellerId: "s2",
    colors: [
      { name: "Camel", hex: "#c4a060", image: "/images/products/product-30.jpg" },
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-31.jpg" },
    ],
    sizes: [0],
    description:
      "Oversized merino wool scarf that doubles as a wrap. The kind of accessory that turns a simple coat into an outfit.",
    features: ["Oversized dimensions", "Merino wool", "Fringed edges", "Lightweight warmth"],
    materials: "100% Extra-fine Merino wool.",
    care: "Hand wash cold. Lay flat to dry.",
    images: [
      "/images/products/product-30.jpg",
      "/images/products/product-31.jpg",
      "/images/products/product-30.jpg",
      "/images/products/product-31.jpg",
    ],
  },

  // ── SportPeak (s3) - Athletic/performance shoes ──
  {
    id: "10",
    name: "Dash Sport",
    slug: "dash-sport-womens",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "new-arrivals", "all"],
    price: 579,
    type: "trainer",
    material: "mesh",
    rating: 4.4,
    reviewCount: 189,
    tags: ["responsive", "reflective", "performance", "breathable"],
    sellerId: "s3",
    colors: [
      { name: "Coral Pink", hex: "#e07a7a", image: "/images/products/product-5.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-10.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10, 11],
    description:
      "Engineered for performance. Responsive cushioning and a breathable upper for your best run yet.",
    features: ["Responsive foam midsole", "Breathable mesh", "Reflective details", "Flexible outsole"],
    materials: "Upper: Recycled mesh. Midsole: Bio-foam. Outsole: Carbon rubber.",
    care: "Spot clean. Air dry. Do not machine wash.",
    badge: "new",
    images: [
      "/images/products/product-5.jpg",
      "/images/products/product-10.jpg",
    ],
  },
  {
    id: "14",
    name: "Tempo Trainer",
    slug: "tempo-trainer",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "sale", "all"],
    price: 359,
    originalPrice: 519,
    type: "trainer",
    material: "mesh",
    rating: 4.1,
    reviewCount: 223,
    tags: ["cross-training", "wide-toe-box", "breathable", "durable"],
    sellerId: "s3",
    colors: [
      { name: "Red", hex: "#9e4040", image: "/images/products/product-7.jpg" },
      { name: "Grey", hex: "#8a8a8a", image: "/images/products/product-16.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12],
    description:
      "A versatile cross-trainer that handles everything from the gym to the street.",
    features: ["Wide toe box", "Flat sole for stability", "Breathable upper", "Durable outsole"],
    materials: "Upper: Recycled polyester. Midsole: EVA foam. Outsole: Rubber.",
    care: "Machine wash cold. Air dry.",
    badge: "sale",
    images: [
      "/images/products/product-7.jpg",
      "/images/products/product-10.jpg",
    ],
  },
  {
    id: "15",
    name: "Tempo Trainer",
    slug: "tempo-trainer-womens",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "sale", "all"],
    price: 359,
    originalPrice: 519,
    type: "trainer",
    material: "mesh",
    rating: 3.9,
    reviewCount: 167,
    tags: ["cross-training", "wide-toe-box", "breathable", "durable"],
    sellerId: "s3",
    colors: [
      { name: "Sage", hex: "#8a9a7a", image: "/images/products/product-3.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-10.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description:
      "A versatile cross-trainer that handles everything from the gym to the street.",
    features: ["Wide toe box", "Flat sole for stability", "Breathable upper", "Durable outsole"],
    materials: "Upper: Recycled polyester. Midsole: EVA foam. Outsole: Rubber.",
    care: "Machine wash cold. Air dry.",
    badge: "sale",
    images: [
      "/images/products/product-3.jpg",
      "/images/products/product-10.jpg",
    ],
  },
  {
    id: "22",
    name: "Performance Sock",
    slug: "performance-sock",
    category: "unisex",
    productCategory: "socks",
    collections: ["mens", "womens", "socks", "new-arrivals", "all"],
    price: 79,
    type: "sock",
    material: "mesh",
    rating: 4.7,
    reviewCount: 89,
    tags: ["performance", "breathable", "cushioned", "arch-support"],
    sellerId: "s3",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-26.jpg" },
      { name: "Grey", hex: "#8a8a8a", image: "/images/products/product-27.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Engineered for active days with targeted cushioning and ventilation zones.",
    features: ["Mesh ventilation zones", "Targeted cushioning", "Compression arch band", "Flat-knit toe seam"],
    materials: "55% Recycled polyester mesh, 40% nylon, 5% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    badge: "new",
    images: ["/images/products/product-26.jpg", "/images/products/product-27.jpg"],
  },
  {
    id: "52",
    name: "Velocity Runner",
    slug: "velocity-runner",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "new-arrivals", "all"],
    price: 549,
    type: "runner",
    material: "mesh",
    rating: 4.6,
    reviewCount: 74,
    tags: ["speed", "lightweight", "race-day", "responsive"],
    sellerId: "s3",
    colors: [
      { name: "Volt", hex: "#c4ff00", image: "/images/products/product-6.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
      { name: "White", hex: "#f0ede6", image: "/images/products/product-9.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "Race-day speed in an everyday package. Carbon-infused plate for propulsion, ultra-lightweight mesh for breathability, and a stack height that eats kilometers. This is the shoe that makes your tempo run feel like recovery.",
    features: ["Carbon-infused plate", "Ultra-lightweight mesh", "High stack midsole", "Rubber outsole pods"],
    materials: "Upper: Engineered mesh. Midsole: Nitrogen-infused foam with carbon plate. Outsole: Rubber pods.",
    care: "Spot clean only. Air dry.",
    badge: "new",
    images: [
      "/images/products/product-6.jpg",
      "/images/products/product-1.jpg",
      "/images/products/product-9.jpg",
      "/images/products/product-10.jpg",
    ],
  },
  {
    id: "53",
    name: "Velocity Runner W",
    slug: "velocity-runner-womens",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "new-arrivals", "all"],
    price: 549,
    type: "runner",
    material: "mesh",
    rating: 4.7,
    reviewCount: 62,
    tags: ["speed", "lightweight", "race-day", "responsive"],
    sellerId: "s3",
    colors: [
      { name: "Coral", hex: "#e07a5f", image: "/images/products/product-5.jpg" },
      { name: "White", hex: "#f0ede6", image: "/images/products/product-11.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10, 11],
    description:
      "Race-day speed in an everyday package. Carbon-infused plate for propulsion, ultra-lightweight mesh that breathes, and a stack height built for distance. Your new PB starts here.",
    features: ["Carbon-infused plate", "Ultra-lightweight mesh", "High stack midsole", "Rubber outsole pods"],
    materials: "Upper: Engineered mesh. Midsole: Nitrogen-infused foam with carbon plate. Outsole: Rubber pods.",
    care: "Spot clean only. Air dry.",
    badge: "new",
    images: [
      "/images/products/product-5.jpg",
      "/images/products/product-11.jpg",
      "/images/products/product-12.jpg",
      "/images/products/product-2.jpg",
    ],
  },
  {
    id: "54",
    name: "Trail Grip",
    slug: "trail-grip",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 499,
    type: "hiker",
    material: "mesh",
    rating: 4.4,
    reviewCount: 45,
    tags: ["trail", "grippy", "waterproof", "performance"],
    sellerId: "s3",
    colors: [
      { name: "Forest", hex: "#3d5a3d", image: "/images/products/product-3.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-7.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "Aggressive trail runner with a Vibram Megagrip outsole that handles mud, rock, and everything between. Waterproof membrane keeps you dry. Built for race day in the mountains.",
    features: ["Vibram Megagrip outsole", "Waterproof membrane", "Rock plate", "Quick-lace system"],
    materials: "Upper: Ripstop mesh with waterproof membrane. Midsole: Compressed EVA. Outsole: Vibram Megagrip.",
    care: "Rinse after trail use. Air dry.",
    images: [
      "/images/products/product-3.jpg",
      "/images/products/product-7.jpg",
      "/images/products/product-14.jpg",
      "/images/products/product-4.jpg",
    ],
  },
  {
    id: "55",
    name: "Power Trainer",
    slug: "power-trainer",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "best-sellers", "all"],
    price: 449,
    type: "trainer",
    material: "mesh",
    rating: 4.5,
    reviewCount: 156,
    tags: ["gym", "flat-sole", "stable", "cross-training"],
    sellerId: "s3",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
      { name: "Grey", hex: "#8a8a8a", image: "/images/products/product-8.jpg" },
      { name: "Red", hex: "#9e4040", image: "/images/products/product-7.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "Flat sole, wide base, zero drop. Built for lifting, HIIT, and everything that needs a stable platform. The outsole wraps up the sidewall for rope climbs.",
    features: ["Zero-drop flat sole", "Wide base", "Sidewall wrap", "Breathable upper"],
    materials: "Upper: Engineered mesh. Midsole: Firm EVA. Outsole: Sticky rubber.",
    care: "Spot clean. Air dry.",
    images: [
      "/images/products/product-1.jpg",
      "/images/products/product-8.jpg",
      "/images/products/product-7.jpg",
      "/images/products/product-10.jpg",
    ],
  },
  {
    id: "56",
    name: "Sprint Tight",
    slug: "sprint-tight-womens",
    category: "women",
    productCategory: "apparel",
    collections: ["womens", "apparel", "all"],
    price: 399,
    type: "pant",
    material: "knit",
    rating: 4.6,
    reviewCount: 83,
    tags: ["performance", "compression", "breathable", "running"],
    sellerId: "s3",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-24.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-25.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "High-waisted running tight with compression zones and a side pocket that actually fits your phone. Squat-proof, sweat-wicking, and designed for movement.",
    features: ["High waist", "Compression zones", "Side phone pocket", "Reflective details"],
    materials: "78% Recycled nylon, 22% elastane.",
    care: "Machine wash cold. Hang dry.",
    images: [
      "/images/products/product-24.jpg",
      "/images/products/product-25.jpg",
      "/images/products/product-24.jpg",
    ],
  },
  {
    id: "57",
    name: "Training Tee",
    slug: "training-tee",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 199,
    type: "tee",
    material: "mesh",
    rating: 4.3,
    reviewCount: 67,
    tags: ["performance", "quick-dry", "breathable", "gym"],
    sellerId: "s3",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-17.jpg" },
      { name: "Grey", hex: "#8a8a8a", image: "/images/products/product-18.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Quick-dry training tee with mesh ventilation panels. Designed to move sweat, not trap it. Athletic fit that stays out of the way during lifts.",
    features: ["Quick-dry fabric", "Mesh ventilation", "Athletic fit", "Flatlock seams"],
    materials: "92% Recycled polyester, 8% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    images: [
      "/images/products/product-17.jpg",
      "/images/products/product-18.jpg",
      "/images/products/product-19.jpg",
    ],
  },
  {
    id: "58",
    name: "Endurance Runner",
    slug: "endurance-runner",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 479,
    type: "runner",
    material: "mesh",
    rating: 4.3,
    reviewCount: 41,
    tags: ["distance", "cushioned", "durable", "neutral"],
    sellerId: "s3",
    colors: [
      { name: "Grey", hex: "#8a8a8a", image: "/images/products/product-8.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "Built for the long run. High-stack cushioning with a durable rubber outsole that lasts 800+ km. Neutral ride, smooth transitions, and enough foam to make marathon distance feel comfortable.",
    features: ["High-stack cushioning", "Durable rubber outsole", "Neutral ride", "Breathable mesh"],
    materials: "Upper: Engineered mesh. Midsole: Dual-density foam. Outsole: High-abrasion rubber.",
    care: "Spot clean. Air dry.",
    images: [
      "/images/products/product-8.jpg",
      "/images/products/product-1.jpg",
      "/images/products/product-6.jpg",
      "/images/products/product-10.jpg",
    ],
  },
  {
    id: "117",
    name: "Recovery Slide",
    slug: "recovery-slide",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "all"],
    price: 249,
    type: "slide",
    material: "mesh",
    rating: 4.5,
    reviewCount: 87,
    tags: ["recovery", "cushioned", "post-workout", "performance"],
    sellerId: "s3",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-16.jpg" },
      { name: "Grey", hex: "#8a8a8a", image: "/images/products/product-8.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11, 12],
    description:
      "Post-workout recovery slide with max cushioning and arch support. The foam is so soft it feels like stepping on a cloud after a hard session.",
    features: ["Max cushion foam", "Arch support", "Quick-dry strap", "Contoured footbed"],
    materials: "Strap: Recycled nylon. Sole: Nitrogen-infused foam.",
    care: "Rinse with water. Air dry.",
    images: [
      "/images/products/product-16.jpg",
      "/images/products/product-8.jpg",
      "/images/products/product-1.jpg",
    ],
  },
  {
    id: "118",
    name: "Track Jacket",
    slug: "track-jacket-mens",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "new-arrivals", "all"],
    price: 449,
    type: "jacket",
    material: "mesh",
    rating: 4.4,
    reviewCount: 31,
    tags: ["performance", "track", "warm-up", "lightweight"],
    sellerId: "s3",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-22.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-23.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "Lightweight track jacket with mesh ventilation and zip pockets. Designed for warm-ups but sharp enough for the street. Reflective details for early-morning runs.",
    features: ["Full zip", "Mesh ventilation panels", "Zip pockets", "Reflective details"],
    materials: "88% Recycled polyester, 12% elastane. Mesh panels.",
    care: "Machine wash cold. Hang dry.",
    badge: "new",
    images: [
      "/images/products/product-22.jpg",
      "/images/products/product-23.jpg",
      "/images/products/product-22.jpg",
    ],
  },
  {
    id: "119",
    name: "Running Short",
    slug: "running-short-mens",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 249,
    type: "pant",
    material: "mesh",
    rating: 4.3,
    reviewCount: 52,
    tags: ["performance", "running", "quick-dry", "lightweight"],
    sellerId: "s3",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-24.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-25.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description:
      "5-inch running shorts with a built-in liner and zip pocket at the back. Split hem for full range of motion. Quick-dry fabric that handles sweat.",
    features: ["Built-in liner", "Back zip pocket", "Split hem", "Quick-dry fabric"],
    materials: "92% Recycled polyester, 8% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    images: [
      "/images/products/product-24.jpg",
      "/images/products/product-25.jpg",
      "/images/products/product-24.jpg",
    ],
  },
  {
    id: "120",
    name: "Stability Trainer W",
    slug: "stability-trainer-womens",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "all"],
    price: 499,
    type: "trainer",
    material: "mesh",
    rating: 4.5,
    reviewCount: 38,
    tags: ["stability", "support", "running", "performance"],
    sellerId: "s3",
    colors: [
      { name: "Grey/Pink", hex: "#8a8a8a", image: "/images/products/product-11.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-10.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10, 11],
    description:
      "Stability running shoe with medial post support and a guide rail system. Prevents overpronation without feeling clunky. Designed specifically for the female foot.",
    features: ["Medial post support", "Guide rail system", "Engineered mesh", "Women's-specific fit"],
    materials: "Upper: Engineered mesh. Midsole: Dual-density foam with medial post. Outsole: Rubber.",
    care: "Spot clean. Air dry.",
    images: [
      "/images/products/product-11.jpg",
      "/images/products/product-10.jpg",
      "/images/products/product-5.jpg",
      "/images/products/product-12.jpg",
    ],
  },

  // ── Modna Szafa (s4) - Unisex basics, everyday shoes ──
  {
    id: "7",
    name: "Classic Walker",
    slug: "classic-walker",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "best-sellers", "all"],
    price: 199,
    type: "walker",
    material: "wool",
    rating: 4.7,
    reviewCount: 487,
    tags: ["machine-washable", "minimalist", "everyday", "cozy"],
    sellerId: "s4",
    colors: [
      { name: "Natural Grey", hex: "#9a9a9a", image: "/images/products/product-8.jpg" },
      { name: "Midnight", hex: "#1a1a2e", image: "/images/products/product-16.jpg" },
      { name: "Cream", hex: "#f0ede6", image: "/images/products/product-9.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description:
      "The shoe that started it all. Soft wool, simple design, endlessly comfortable.",
    features: ["Merino wool upper", "Cushioned footbed", "Minimalist design", "Machine washable"],
    materials: "Upper: ZQ Merino wool. Midsole: Sugarcane EVA. Outsole: SweetFoam.",
    care: "Remove insoles and laces. Machine wash cold on gentle. Air dry.",
    badge: "bestseller",
    images: [
      "/images/products/product-8.jpg",
      "/images/products/product-16.jpg",
      "/images/products/product-9.jpg",
    ],
  },
  {
    id: "8",
    name: "Classic Walker",
    slug: "classic-walker-womens",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "best-sellers", "all"],
    price: 199,
    type: "walker",
    material: "wool",
    rating: 4.6,
    reviewCount: 392,
    tags: ["machine-washable", "minimalist", "everyday", "cozy"],
    sellerId: "s4",
    colors: [
      { name: "Lavender", hex: "#b5a7c9", image: "/images/products/product-12.jpg" },
      { name: "Natural Grey", hex: "#9a9a9a", image: "/images/products/product-11.jpg" },
      { name: "Cream", hex: "#f0ede6", image: "/images/products/product-2.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description:
      "The shoe that started it all. Soft wool, simple design, endlessly comfortable.",
    features: ["Merino wool upper", "Cushioned footbed", "Minimalist design", "Machine washable"],
    materials: "Upper: ZQ Merino wool. Midsole: Sugarcane EVA. Outsole: SweetFoam.",
    care: "Remove insoles and laces. Machine wash cold on gentle. Air dry.",
    images: [
      "/images/products/product-12.jpg",
      "/images/products/product-11.jpg",
      "/images/products/product-2.jpg",
    ],
  },
  {
    id: "13",
    name: "Coast Slide",
    slug: "coast-slide",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "new-arrivals", "all"],
    price: 109,
    type: "slide",
    material: "tree-fiber",
    rating: 4.2,
    reviewCount: 347,
    tags: ["easy-on", "quick-dry", "lightweight", "casual"],
    sellerId: "s4",
    colors: [
      { name: "Sand", hex: "#c4b59a", image: "/images/products/product-8.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-16.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11, 12],
    description:
      "The easiest shoe you'll ever own. Slip on, step out, done.",
    features: ["Sugarcane foam", "Contoured footbed", "Quick-dry material", "Lightweight"],
    materials: "Body: Sugarcane-based foam. Strap: Recycled nylon.",
    care: "Rinse with water. Air dry.",
    badge: "new",
    images: [
      "/images/products/product-8.jpg",
      "/images/products/product-16.jpg",
    ],
  },
  {
    id: "23",
    name: "Classic Tee",
    slug: "classic-tee-mens",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "new-arrivals", "all"],
    price: 89,
    type: "tee",
    material: "tree-fiber",
    rating: 4.6,
    reviewCount: 175,
    tags: ["soft", "breathable", "everyday", "sustainable"],
    sellerId: "s4",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-17.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-18.jpg" },
      { name: "Olive", hex: "#5c6b4f", image: "/images/products/product-19.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Soft tee from eucalyptus fiber. Light, breathable, ready for anything.",
    features: ["Tree-fiber fabric", "Relaxed fit", "Tagless label", "Pre-shrunk"],
    materials: "100% Eucalyptus tree fiber (TENCEL Lyocell).",
    care: "Machine wash cold. Tumble dry low. Do not iron.",
    badge: "new",
    images: ["/images/products/product-17.jpg", "/images/products/product-18.jpg"],
  },
  {
    id: "24",
    name: "Classic Tee",
    slug: "classic-tee-womens",
    category: "women",
    productCategory: "apparel",
    collections: ["womens", "apparel", "new-arrivals", "all"],
    price: 89,
    type: "tee",
    material: "tree-fiber",
    rating: 4.7,
    reviewCount: 193,
    tags: ["soft", "breathable", "everyday", "sustainable"],
    sellerId: "s4",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-17.jpg" },
      { name: "Blush", hex: "#d4a5a5", image: "/images/products/product-18.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-19.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Soft tee from eucalyptus fiber. Light, breathable, ready for anything.",
    features: ["Tree-fiber fabric", "Relaxed fit", "Tagless label", "Pre-shrunk"],
    materials: "100% Eucalyptus tree fiber (TENCEL Lyocell).",
    care: "Machine wash cold. Tumble dry low. Do not iron.",
    badge: "new",
    images: ["/images/products/product-17.jpg", "/images/products/product-18.jpg"],
  },
  {
    id: "59",
    name: "Day Walker",
    slug: "day-walker",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "all"],
    price: 149,
    type: "walker",
    material: "knit",
    rating: 4.4,
    reviewCount: 67,
    tags: ["everyday", "comfortable", "casual", "lightweight"],
    sellerId: "s4",
    colors: [
      { name: "Grey", hex: "#9a9a9a", image: "/images/products/product-8.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-6.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11, 12],
    description: "Simple everyday walker. Knit upper, foam sole, nothing fancy. Just comfortable.",
    features: ["Knit upper", "Foam midsole", "Rubber outsole", "Removable insole"],
    materials: "Upper: Recycled knit. Midsole: EVA foam. Outsole: Rubber.",
    care: "Machine wash cold. Air dry.",
    images: ["/images/products/product-8.jpg", "/images/products/product-6.jpg"],
  },
  {
    id: "60",
    name: "Basic Hoodie",
    slug: "basic-hoodie-unisex",
    category: "unisex",
    productCategory: "apparel",
    collections: ["mens", "womens", "apparel", "all"],
    price: 149,
    type: "hoodie",
    material: "knit",
    rating: 4.5,
    reviewCount: 89,
    tags: ["basic", "warm", "everyday", "unisex"],
    sellerId: "s4",
    colors: [
      { name: "Grey", hex: "#8a8a8a", image: "/images/products/product-20.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-21.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-20.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "No-frills hoodie. Good fabric, good fit, good price. That's it.",
    features: ["Kangaroo pocket", "Drawcord hood", "Ribbed cuffs", "Regular fit"],
    materials: "80% Cotton, 20% polyester. 300gsm.",
    care: "Machine wash cold. Tumble dry low.",
    images: ["/images/products/product-20.jpg", "/images/products/product-21.jpg"],
  },
  {
    id: "61",
    name: "Canvas Slip-On",
    slug: "canvas-slip-on",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "all"],
    price: 119,
    type: "slip-on",
    material: "tree-fiber",
    rating: 4.2,
    reviewCount: 134,
    tags: ["casual", "easy-on", "lightweight", "summer"],
    sellerId: "s4",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-9.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-16.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11, 12],
    description: "Canvas slip-on for summer. Elastic gusset, vulcanized sole. Simple.",
    features: ["Canvas upper", "Elastic gusset", "Vulcanized sole", "Removable insole"],
    materials: "Upper: Organic cotton canvas. Sole: Vulcanized rubber.",
    care: "Machine wash cold. Air dry.",
    images: ["/images/products/product-9.jpg", "/images/products/product-16.jpg"],
  },
  {
    id: "62",
    name: "Jogger Basic",
    slug: "jogger-basic",
    category: "unisex",
    productCategory: "apparel",
    collections: ["mens", "womens", "apparel", "all"],
    price: 129,
    type: "pant",
    material: "knit",
    rating: 4.3,
    reviewCount: 56,
    tags: ["basic", "comfortable", "everyday", "unisex"],
    sellerId: "s4",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-24.jpg" },
      { name: "Grey", hex: "#8a8a8a", image: "/images/products/product-25.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Everyday joggers. Elastic waist, tapered leg, side pockets. Nothing more, nothing less.",
    features: ["Elastic waist", "Tapered leg", "Side pockets", "Regular fit"],
    materials: "80% Cotton, 20% polyester.",
    care: "Machine wash cold. Tumble dry low.",
    images: ["/images/products/product-24.jpg", "/images/products/product-25.jpg"],
  },
  {
    id: "63",
    name: "Weekend Sneaker",
    slug: "weekend-sneaker",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "all"],
    price: 179,
    type: "walker",
    material: "knit",
    rating: 4.3,
    reviewCount: 45,
    tags: ["casual", "comfortable", "weekend", "lightweight"],
    sellerId: "s4",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-9.jpg" },
      { name: "Grey", hex: "#9a9a9a", image: "/images/products/product-8.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-6.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11, 12],
    description: "Low-key sneaker for lazy weekends and coffee runs. Knit upper, comfy sole.",
    features: ["Knit upper", "Cushioned midsole", "Rubber outsole", "Padded collar"],
    materials: "Upper: Recycled knit. Midsole: EVA. Outsole: Rubber.",
    care: "Machine wash cold. Air dry.",
    images: ["/images/products/product-9.jpg", "/images/products/product-8.jpg"],
  },
  {
    id: "121",
    name: "Basic Crew Sock",
    slug: "basic-crew-sock",
    category: "unisex",
    productCategory: "socks",
    collections: ["mens", "womens", "socks", "all"],
    price: 29,
    type: "sock",
    material: "tree-fiber",
    rating: 4.2,
    reviewCount: 78,
    tags: ["basic", "everyday", "comfortable"],
    sellerId: "s4",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-26.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-27.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Basic crew socks. Cotton blend, reinforced toe and heel. 3-pack.",
    features: ["Cotton blend", "Crew height", "Reinforced toe and heel"],
    materials: "80% Cotton, 18% nylon, 2% elastane.",
    care: "Machine wash. Tumble dry.",
    images: ["/images/products/product-26.jpg", "/images/products/product-27.jpg"],
  },
  {
    id: "122",
    name: "Everyday Flat",
    slug: "everyday-flat",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "all"],
    price: 139,
    type: "flat",
    material: "knit",
    rating: 4.3,
    reviewCount: 43,
    tags: ["everyday", "comfortable", "simple", "lightweight"],
    sellerId: "s4",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-10.jpg" },
      { name: "Beige", hex: "#c4b59a", image: "/images/products/product-15.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description: "Simple knit flat for everyday. Cushioned insole, flexible sole. Nothing fancy, just comfortable.",
    features: ["Knit upper", "Cushioned insole", "Flexible sole", "Slip-on"],
    materials: "Upper: Recycled knit. Sole: EVA.",
    care: "Machine wash cold. Air dry.",
    images: ["/images/products/product-10.jpg", "/images/products/product-15.jpg"],
  },

  // ── Sneaker Lab (s5) - Curated sneakers ──
  {
    id: "64",
    name: "Lab Runner 001",
    slug: "lab-runner-001",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "new-arrivals", "all"],
    price: 249,
    type: "runner",
    material: "mesh",
    rating: 4.5,
    reviewCount: 34,
    tags: ["curated", "runner", "cushioned", "clean"],
    sellerId: "s5",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-9.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
      { name: "Grey", hex: "#8a8a8a", image: "/images/products/product-8.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12],
    description: "Clean runner with a minimal profile. Hand-picked by the Lab team for its silhouette and comfort balance.",
    features: ["Mesh upper", "EVA midsole", "Rubber outsole", "Padded collar"],
    materials: "Upper: Recycled mesh. Midsole: EVA. Outsole: Rubber.",
    care: "Spot clean. Air dry.",
    images: ["/images/products/product-9.jpg", "/images/products/product-1.jpg"],
  },
  {
    id: "65",
    name: "Lab Runner 002",
    slug: "lab-runner-002",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "new-arrivals", "all"],
    price: 249,
    type: "runner",
    material: "mesh",
    rating: 4.6,
    reviewCount: 28,
    tags: ["curated", "runner", "cushioned", "tonal"],
    sellerId: "s5",
    colors: [
      { name: "Blush", hex: "#d4a5a5", image: "/images/products/product-12.jpg" },
      { name: "White", hex: "#f0ede6", image: "/images/products/product-11.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description: "Tonal runner in a women's-specific last. Curated by the Lab for clean lines and all-day comfort.",
    features: ["Mesh upper", "EVA midsole", "Rubber outsole", "Women's-specific last"],
    materials: "Upper: Recycled mesh. Midsole: EVA. Outsole: Rubber.",
    care: "Spot clean. Air dry.",
    images: ["/images/products/product-12.jpg", "/images/products/product-11.jpg"],
  },
  {
    id: "66",
    name: "Lab Trainer Classic",
    slug: "lab-trainer-classic",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "best-sellers", "all"],
    price: 219,
    type: "trainer",
    material: "leather",
    rating: 4.4,
    reviewCount: 72,
    tags: ["curated", "trainer", "leather", "classic"],
    sellerId: "s5",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-9.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12, 13],
    description: "Leather trainer with a retro profile. The kind of sneaker that goes with everything - jeans, chinos, whatever.",
    features: ["Leather upper", "Cushioned footbed", "Rubber outsole", "Retro silhouette"],
    materials: "Upper: Full-grain leather. Midsole: EVA. Outsole: Rubber.",
    care: "Wipe with damp cloth. Condition leather periodically.",
    images: ["/images/products/product-9.jpg", "/images/products/product-1.jpg"],
  },
  {
    id: "67",
    name: "Lab Knit Runner",
    slug: "lab-knit-runner",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "all"],
    price: 229,
    type: "runner",
    material: "knit",
    rating: 4.3,
    reviewCount: 41,
    tags: ["curated", "knit", "lightweight", "breathable"],
    sellerId: "s5",
    colors: [
      { name: "Grey", hex: "#9a9a9a", image: "/images/products/product-8.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-6.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11, 12],
    description: "Full-knit runner, zero waste construction. Sock-like fit, responsive sole. Lab-selected.",
    features: ["Full-knit upper", "Sock-like collar", "EVA midsole", "Rubber outsole"],
    materials: "Upper: Recycled knit. Midsole: EVA. Outsole: Rubber.",
    care: "Machine wash cold. Air dry.",
    images: ["/images/products/product-8.jpg", "/images/products/product-6.jpg"],
  },
  {
    id: "68",
    name: "Lab High Top",
    slug: "lab-high-top",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "new-arrivals", "all"],
    price: 239,
    type: "trainer",
    material: "leather",
    rating: 4.2,
    reviewCount: 19,
    tags: ["curated", "high-top", "leather", "statement"],
    sellerId: "s5",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
      { name: "White", hex: "#f0ede6", image: "/images/products/product-9.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12],
    description: "High-top in full-grain leather. Padded collar, flat sole, statement piece. Not for blending in.",
    features: ["Full-grain leather", "Padded collar", "Flat sole", "High-top silhouette"],
    materials: "Upper: Full-grain leather. Midsole: EVA. Outsole: Rubber.",
    care: "Wipe clean. Condition leather.",
    badge: "new",
    images: ["/images/products/product-1.jpg", "/images/products/product-9.jpg"],
  },
  {
    id: "69",
    name: "Lab Suede Trainer",
    slug: "lab-suede-trainer",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 229,
    type: "trainer",
    material: "leather",
    rating: 4.5,
    reviewCount: 33,
    tags: ["curated", "suede", "retro", "premium"],
    sellerId: "s5",
    colors: [
      { name: "Sand", hex: "#c4b59a", image: "/images/products/product-14.jpg" },
      { name: "Forest", hex: "#3d5a3d", image: "/images/products/product-3.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12],
    description: "Suede trainer in a retro silhouette. Gum sole, tonal laces. The kind of shoe people ask about.",
    features: ["Suede upper", "Gum rubber sole", "Tonal laces", "Cushioned insole"],
    materials: "Upper: Suede leather. Midsole: EVA. Outsole: Gum rubber.",
    care: "Use suede brush. Apply protector spray.",
    images: ["/images/products/product-14.jpg", "/images/products/product-3.jpg"],
  },
  {
    id: "70",
    name: "Lab Slip-On",
    slug: "lab-slip-on",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "all"],
    price: 199,
    type: "slip-on",
    material: "knit",
    rating: 4.4,
    reviewCount: 22,
    tags: ["curated", "slip-on", "minimal", "easy"],
    sellerId: "s5",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-11.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-10.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description: "Minimal slip-on with a knit upper. Easy on, easy off, easy outfit.",
    features: ["Knit upper", "Elastic gusset", "EVA sole", "Cushioned insole"],
    materials: "Upper: Recycled knit. Sole: EVA. Outsole: Rubber.",
    care: "Machine wash cold. Air dry.",
    images: ["/images/products/product-11.jpg", "/images/products/product-10.jpg"],
  },
  {
    id: "71",
    name: "Lab Runner 003",
    slug: "lab-runner-003",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 209,
    type: "runner",
    material: "mesh",
    rating: 4.1,
    reviewCount: 15,
    tags: ["curated", "runner", "value", "everyday"],
    sellerId: "s5",
    colors: [
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-7.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-6.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12],
    description: "Entry-level Lab runner. Same curation standards, friendlier price point.",
    features: ["Mesh upper", "Foam midsole", "Rubber outsole", "Removable insole"],
    materials: "Upper: Recycled mesh. Midsole: EVA. Outsole: Rubber.",
    care: "Machine wash cold. Air dry.",
    images: ["/images/products/product-7.jpg", "/images/products/product-6.jpg"],
  },
  {
    id: "72",
    name: "Lab Platform",
    slug: "lab-platform",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "new-arrivals", "all"],
    price: 239,
    type: "walker",
    material: "leather",
    rating: 4.3,
    reviewCount: 11,
    tags: ["curated", "platform", "leather", "bold"],
    sellerId: "s5",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-2.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-10.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9, 10],
    description: "Platform sneaker in smooth leather. Lab-picked for its proportions and comfort.",
    features: ["Leather upper", "Platform sole", "Padded collar", "Cushioned insole"],
    materials: "Upper: Smooth leather. Midsole: EVA platform. Outsole: Rubber.",
    care: "Wipe clean with damp cloth.",
    badge: "new",
    images: ["/images/products/product-2.jpg", "/images/products/product-10.jpg"],
  },
  {
    id: "123",
    name: "Lab Canvas Low",
    slug: "lab-canvas-low",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "all"],
    price: 189,
    type: "trainer",
    material: "tree-fiber",
    rating: 4.2,
    reviewCount: 17,
    tags: ["curated", "canvas", "minimal", "summer"],
    sellerId: "s5",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-9.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11, 12],
    description: "Low-top canvas sneaker with a vulcanized sole. Lab pick for its clean lines and summer versatility.",
    features: ["Canvas upper", "Vulcanized sole", "Padded insole", "Low-top"],
    materials: "Upper: Organic cotton canvas. Sole: Vulcanized rubber.",
    care: "Machine wash cold. Air dry.",
    images: ["/images/products/product-9.jpg", "/images/products/product-1.jpg"],
  },

  // ── EcoThreads (s6) - Sustainable items ──
  {
    id: "17",
    name: "Ankle Sock",
    slug: "ankle-sock-mens",
    category: "men",
    productCategory: "socks",
    collections: ["mens", "socks", "new-arrivals", "all"],
    price: 49,
    type: "sock",
    material: "wool",
    rating: 4.5,
    reviewCount: 198,
    tags: ["everyday", "breathable", "moisture-wicking"],
    sellerId: "s6",
    colors: [
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-26.jpg" },
      { name: "White", hex: "#f0ede6", image: "/images/products/product-27.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-26.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Soft merino wool ankle socks that keep your feet cool and dry all day.",
    features: ["Merino wool blend", "Ankle height", "Moisture-wicking", "Seamless toe"],
    materials: "65% Merino wool, 33% nylon, 2% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    badge: "new",
    images: ["/images/products/product-26.jpg", "/images/products/product-27.jpg"],
  },
  {
    id: "18",
    name: "Ankle Sock",
    slug: "ankle-sock-womens",
    category: "women",
    productCategory: "socks",
    collections: ["womens", "socks", "new-arrivals", "all"],
    price: 49,
    type: "sock",
    material: "wool",
    rating: 4.6,
    reviewCount: 210,
    tags: ["everyday", "breathable", "moisture-wicking"],
    sellerId: "s6",
    colors: [
      { name: "Blush", hex: "#d4a5a5", image: "/images/products/product-26.jpg" },
      { name: "White", hex: "#f0ede6", image: "/images/products/product-27.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-26.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Soft merino wool ankle socks that keep your feet cool and dry all day.",
    features: ["Merino wool blend", "Ankle height", "Moisture-wicking", "Seamless toe"],
    materials: "65% Merino wool, 33% nylon, 2% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    badge: "new",
    images: ["/images/products/product-26.jpg", "/images/products/product-27.jpg"],
  },
  {
    id: "19",
    name: "Crew Sock",
    slug: "crew-sock-mens",
    category: "men",
    productCategory: "socks",
    collections: ["mens", "socks", "all"],
    price: 59,
    type: "sock",
    material: "wool",
    rating: 4.4,
    reviewCount: 142,
    tags: ["crew-length", "warm", "cushioned"],
    sellerId: "s6",
    colors: [
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-26.jpg" },
      { name: "Cream", hex: "#f0ede6", image: "/images/products/product-27.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Mid-calf crew socks with extra cushioning at the heel and toe.",
    features: ["Merino wool blend", "Crew height", "Reinforced heel and toe", "Arch support"],
    materials: "60% Merino wool, 37% nylon, 3% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    images: ["/images/products/product-26.jpg", "/images/products/product-27.jpg"],
  },
  {
    id: "20",
    name: "Crew Sock",
    slug: "crew-sock-womens",
    category: "women",
    productCategory: "socks",
    collections: ["womens", "socks", "all"],
    price: 59,
    type: "sock",
    material: "wool",
    rating: 4.5,
    reviewCount: 127,
    tags: ["crew-length", "warm", "cushioned"],
    sellerId: "s6",
    colors: [
      { name: "Lavender", hex: "#b5a7c9", image: "/images/products/product-26.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-27.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Mid-calf crew socks with extra cushioning at the heel and toe.",
    features: ["Merino wool blend", "Crew height", "Reinforced heel and toe", "Arch support"],
    materials: "60% Merino wool, 37% nylon, 3% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    images: ["/images/products/product-26.jpg", "/images/products/product-27.jpg"],
  },
  {
    id: "21",
    name: "No-Show Sock",
    slug: "no-show-sock",
    category: "unisex",
    productCategory: "socks",
    collections: ["mens", "womens", "socks", "all"],
    price: 49,
    type: "sock",
    material: "tree-fiber",
    rating: 4.3,
    reviewCount: 256,
    tags: ["invisible", "breathable", "no-slip"],
    sellerId: "s6",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-26.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-27.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Truly invisible socks with a silicone grip heel to stay in place.",
    features: ["Tree-fiber blend", "No-show height", "Silicone heel grip", "Breathable mesh top"],
    materials: "70% Eucalyptus tree fiber, 28% nylon, 2% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    images: ["/images/products/product-26.jpg", "/images/products/product-27.jpg"],
  },
  {
    id: "73",
    name: "Eco Walker",
    slug: "eco-walker",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "all"],
    price: 189,
    type: "walker",
    material: "wool",
    rating: 4.6,
    reviewCount: 78,
    tags: ["sustainable", "comfortable", "everyday", "organic"],
    sellerId: "s6",
    colors: [
      { name: "Sage", hex: "#8a9a7a", image: "/images/products/product-3.jpg" },
      { name: "Oatmeal", hex: "#c4b59a", image: "/images/products/product-8.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11, 12],
    description: "Walker made from ZQ-certified merino wool and sugarcane EVA. Carbon-neutral production. Comfortable and responsible.",
    features: ["ZQ Merino upper", "Sugarcane EVA midsole", "Natural rubber outsole", "Carbon-neutral"],
    materials: "Upper: ZQ Merino wool. Midsole: Sugarcane EVA. Outsole: Natural rubber.",
    care: "Machine wash cold. Air dry.",
    images: ["/images/products/product-3.jpg", "/images/products/product-8.jpg"],
  },
  {
    id: "74",
    name: "Organic Tee",
    slug: "organic-tee-unisex",
    category: "unisex",
    productCategory: "apparel",
    collections: ["mens", "womens", "apparel", "all"],
    price: 99,
    type: "tee",
    material: "tree-fiber",
    rating: 4.7,
    reviewCount: 134,
    tags: ["organic", "sustainable", "soft", "everyday"],
    sellerId: "s6",
    colors: [
      { name: "Natural", hex: "#c4b59a", image: "/images/products/product-17.jpg" },
      { name: "Sage", hex: "#8a9a7a", image: "/images/products/product-18.jpg" },
      { name: "White", hex: "#f0ede6", image: "/images/products/product-19.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "100% organic tee. GOTS certified, enzyme-washed for softness, made in a fair-trade facility.",
    features: ["GOTS certified organic", "Enzyme-washed", "Relaxed fit", "Tagless label"],
    materials: "100% GOTS-certified organic cotton.",
    care: "Machine wash cold. Tumble dry low.",
    images: ["/images/products/product-17.jpg", "/images/products/product-18.jpg"],
  },
  {
    id: "75",
    name: "Hemp Runner",
    slug: "hemp-runner",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "new-arrivals", "all"],
    price: 219,
    type: "runner",
    material: "tree-fiber",
    rating: 4.4,
    reviewCount: 23,
    tags: ["hemp", "sustainable", "breathable", "natural"],
    sellerId: "s6",
    colors: [
      { name: "Natural", hex: "#c4b59a", image: "/images/products/product-8.jpg" },
      { name: "Olive", hex: "#5c6b4f", image: "/images/products/product-3.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11, 12],
    description: "Runner made from hemp canvas. Naturally antimicrobial, incredibly breathable, low water footprint.",
    features: ["Hemp canvas upper", "Cork insole", "Natural rubber outsole", "Antimicrobial"],
    materials: "Upper: Hemp canvas. Insole: Cork. Outsole: Natural rubber.",
    care: "Spot clean. Air dry.",
    badge: "new",
    images: ["/images/products/product-8.jpg", "/images/products/product-3.jpg"],
  },
  {
    id: "76",
    name: "Recycled Hoodie",
    slug: "recycled-hoodie",
    category: "unisex",
    productCategory: "apparel",
    collections: ["mens", "womens", "apparel", "all"],
    price: 179,
    type: "hoodie",
    material: "knit",
    rating: 4.5,
    reviewCount: 45,
    tags: ["recycled", "sustainable", "warm", "cozy"],
    sellerId: "s6",
    colors: [
      { name: "Olive", hex: "#5c6b4f", image: "/images/products/product-20.jpg" },
      { name: "Grey", hex: "#8a8a8a", image: "/images/products/product-21.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Hoodie made from 100% recycled plastic bottles. 12 bottles per hoodie. Same comfort, less waste.",
    features: ["100% recycled polyester", "Kangaroo pocket", "Drawcord hood", "Regular fit"],
    materials: "100% Recycled polyester (12 PET bottles per hoodie).",
    care: "Machine wash cold. Hang dry.",
    images: ["/images/products/product-20.jpg", "/images/products/product-21.jpg"],
  },
  {
    id: "77",
    name: "Bamboo Sock",
    slug: "bamboo-sock",
    category: "unisex",
    productCategory: "socks",
    collections: ["mens", "womens", "socks", "all"],
    price: 39,
    type: "sock",
    material: "tree-fiber",
    rating: 4.6,
    reviewCount: 89,
    tags: ["bamboo", "sustainable", "soft", "breathable"],
    sellerId: "s6",
    colors: [
      { name: "Natural", hex: "#c4b59a", image: "/images/products/product-26.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-27.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Bamboo fiber socks. Softer than cotton, naturally temperature-regulating, biodegradable.",
    features: ["Bamboo fiber blend", "Temperature regulating", "Ankle height", "Biodegradable"],
    materials: "70% Bamboo viscose, 28% nylon, 2% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    images: ["/images/products/product-26.jpg", "/images/products/product-27.jpg"],
  },

  // ── Classic Fit (s7) - Men's smart casual ──
  {
    id: "5",
    name: "Stride Loafer",
    slug: "stride-loafer",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "new-arrivals", "all"],
    price: 219,
    type: "loafer",
    material: "wool",
    rating: 4.4,
    reviewCount: 134,
    tags: ["smart-casual", "collapsible-heel", "versatile"],
    sellerId: "s7",
    colors: [
      { name: "Espresso", hex: "#4a3728", image: "/images/products/product-4.jpg" },
      { name: "Slate", hex: "#6b7280", image: "/images/products/product-14.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12],
    description:
      "A modern loafer that bridges casual and polished. Soft wool upper with a supportive footbed.",
    features: ["Wool upper", "Contoured footbed", "Collapsible heel", "Slip-resistant sole"],
    materials: "Upper: ZQ Merino wool. Midsole: Castor bean foam. Outsole: Natural rubber.",
    care: "Spot clean with damp cloth. Air dry.",
    badge: "new",
    images: [
      "/images/products/product-4.jpg",
      "/images/products/product-14.jpg",
    ],
  },
  {
    id: "78",
    name: "Oxford Walker",
    slug: "oxford-walker",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 249,
    type: "walker",
    material: "leather",
    rating: 4.5,
    reviewCount: 56,
    tags: ["smart-casual", "leather", "office", "classic"],
    sellerId: "s7",
    colors: [
      { name: "Brown", hex: "#6b5b4a", image: "/images/products/product-14.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-4.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12],
    description: "Leather walker with oxford styling. Dress shoe comfort, sneaker cushioning. Works with chinos or jeans.",
    features: ["Full-grain leather", "Cushioned footbed", "Rubber outsole", "Oxford styling"],
    materials: "Upper: Full-grain leather. Midsole: EVA. Outsole: Rubber.",
    care: "Wipe with damp cloth. Condition leather.",
    images: ["/images/products/product-14.jpg", "/images/products/product-4.jpg"],
  },
  {
    id: "79",
    name: "Polo Knit",
    slug: "polo-knit-mens",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 149,
    type: "tee",
    material: "knit",
    rating: 4.3,
    reviewCount: 34,
    tags: ["smart-casual", "polo", "breathable", "office"],
    sellerId: "s7",
    colors: [
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-17.jpg" },
      { name: "White", hex: "#f0ede6", image: "/images/products/product-18.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Knit polo with a clean collar and two-button placket. Smart enough for the office, comfortable enough for the weekend.",
    features: ["Knit construction", "Two-button placket", "Ribbed collar", "Regular fit"],
    materials: "100% Merino wool.",
    care: "Machine wash cold gentle. Lay flat to dry.",
    images: ["/images/products/product-17.jpg", "/images/products/product-18.jpg"],
  },
  {
    id: "80",
    name: "Penny Loafer",
    slug: "penny-loafer",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 239,
    type: "loafer",
    material: "leather",
    rating: 4.6,
    reviewCount: 42,
    tags: ["classic", "leather", "smart-casual", "office"],
    sellerId: "s7",
    colors: [
      { name: "Cognac", hex: "#8b4513", image: "/images/products/product-4.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-14.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12],
    description: "Classic penny loafer in full-grain leather. Cushioned insole, leather sole with rubber heel. Timeless.",
    features: ["Full-grain leather", "Leather sole", "Rubber heel", "Cushioned insole"],
    materials: "Upper: Full-grain leather. Sole: Leather with rubber heel.",
    care: "Polish regularly. Use shoe trees.",
    images: ["/images/products/product-4.jpg", "/images/products/product-14.jpg"],
  },
  {
    id: "81",
    name: "Chino Pant",
    slug: "chino-pant-mens",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 179,
    type: "pant",
    material: "tree-fiber",
    rating: 4.4,
    reviewCount: 28,
    tags: ["smart-casual", "chino", "versatile", "comfortable"],
    sellerId: "s7",
    colors: [
      { name: "Khaki", hex: "#c4b59a", image: "/images/products/product-24.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-25.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Stretch chino with a modern taper. Office-friendly, weekend-ready. Two-way stretch for comfort.",
    features: ["Two-way stretch", "Modern taper", "Slash pockets", "Button closure"],
    materials: "97% Organic cotton, 3% elastane.",
    care: "Machine wash cold. Tumble dry low.",
    images: ["/images/products/product-24.jpg", "/images/products/product-25.jpg"],
  },
  {
    id: "82",
    name: "Merino V-Neck",
    slug: "merino-vneck",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 169,
    type: "cardigan",
    material: "wool",
    rating: 4.5,
    reviewCount: 19,
    tags: ["smart-casual", "merino", "layering", "classic"],
    sellerId: "s7",
    colors: [
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-22.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-23.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Lightweight merino V-neck sweater. Layer it over a shirt or wear it on its own. Breathable, itch-free, machine washable.",
    features: ["V-neckline", "Lightweight knit", "Machine washable", "Regular fit"],
    materials: "100% Extra-fine Merino wool.",
    care: "Machine wash cold gentle. Lay flat to dry.",
    images: ["/images/products/product-22.jpg", "/images/products/product-23.jpg"],
  },
  {
    id: "83",
    name: "Suede Desert Boot",
    slug: "suede-desert-boot",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "new-arrivals", "all"],
    price: 249,
    type: "hiker",
    material: "leather",
    rating: 4.3,
    reviewCount: 15,
    tags: ["desert-boot", "suede", "smart-casual", "classic"],
    sellerId: "s7",
    colors: [
      { name: "Sand", hex: "#c4b59a", image: "/images/products/product-14.jpg" },
      { name: "Dark Brown", hex: "#4a3728", image: "/images/products/product-4.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12],
    description: "Classic desert boot in soft suede. Crepe sole, two-eyelet lacing. A staple.",
    features: ["Suede upper", "Crepe rubber sole", "Two-eyelet lacing", "Cushioned insole"],
    materials: "Upper: Suede. Sole: Crepe rubber.",
    care: "Use suede brush. Apply protector spray. Avoid water.",
    badge: "new",
    images: ["/images/products/product-14.jpg", "/images/products/product-4.jpg"],
  },
  {
    id: "84",
    name: "Linen Shirt",
    slug: "linen-shirt-mens",
    category: "men",
    productCategory: "apparel",
    collections: ["mens", "apparel", "all"],
    price: 189,
    type: "tee",
    material: "tree-fiber",
    rating: 4.2,
    reviewCount: 11,
    tags: ["linen", "summer", "smart-casual", "breathable"],
    sellerId: "s7",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-17.jpg" },
      { name: "Sky Blue", hex: "#87CEEB", image: "/images/products/product-18.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Pure linen shirt with a camp collar. Relaxed but put-together. Gets better with every wash.",
    features: ["Camp collar", "Button front", "Chest pocket", "Relaxed fit"],
    materials: "100% European linen.",
    care: "Machine wash cold. Hang dry. Iron on medium.",
    images: ["/images/products/product-17.jpg", "/images/products/product-18.jpg"],
  },

  // ── Marta Handmade (s8) - Handmade shoes, unique items ──
  {
    id: "85",
    name: "Ręczne Baleriny",
    slug: "reczne-baleriny",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "all"],
    price: 179,
    type: "flat",
    material: "leather",
    rating: 4.3,
    reviewCount: 8,
    tags: ["handmade", "leather", "unique"],
    sellerId: "s8",
    colors: [
      { name: "Red", hex: "#9e4040", image: "/images/products/product-5.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9],
    description: "Ręcznie szyte baleriny ze skóry naturalnej. Każda para trochę inna.",
    features: ["Handmade", "Natural leather", "Leather sole"],
    materials: "Skóra naturalna.",
    care: "Czyścić miękką szmatką. Impregnować.",
    images: ["/images/products/product-5.jpg"],
  },
  {
    id: "86",
    name: "Kolorowe Mokasyny",
    slug: "kolorowe-mokasyny",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "all"],
    price: 169,
    type: "loafer",
    material: "leather",
    rating: 4.1,
    reviewCount: 5,
    tags: ["handmade", "colorful", "leather"],
    sellerId: "s8",
    colors: [
      { name: "Turquoise", hex: "#40a09e", image: "/images/products/product-2.jpg" },
      { name: "Yellow", hex: "#c4a040", image: "/images/products/product-15.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9],
    description: "Mokasyny w żywych kolorach. Ręcznie farbowane, skóra miękka jak masło.",
    features: ["Hand-dyed", "Soft leather", "Flexible sole"],
    materials: "Skóra naturalna barwiona ręcznie.",
    care: "Unikać deszczu. Czyścić suchą szmatką.",
    images: ["/images/products/product-2.jpg", "/images/products/product-15.jpg"],
  },
  {
    id: "87",
    name: "Skórzane Sandały",
    slug: "skorzane-sandaly",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "new-arrivals", "all"],
    price: 149,
    type: "slide",
    material: "leather",
    rating: 4.0,
    reviewCount: 3,
    tags: ["handmade", "sandal", "summer", "leather"],
    sellerId: "s8",
    colors: [
      { name: "Tan", hex: "#c4a060", image: "/images/products/product-14.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9],
    description: "Skórzane sandały na lato. Ręczna robota, naturalna skóra, wygodna podeszwa.",
    features: ["Handmade", "Leather straps", "Cork footbed"],
    materials: "Skóra naturalna, korek.",
    care: "Czyścić wilgotną szmatką.",
    badge: "new",
    images: ["/images/products/product-14.jpg"],
  },
  {
    id: "88",
    name: "Patchwork Flat",
    slug: "patchwork-flat",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "all"],
    price: 159,
    type: "flat",
    material: "leather",
    rating: 4.2,
    reviewCount: 6,
    tags: ["handmade", "patchwork", "unique", "colorful"],
    sellerId: "s8",
    colors: [
      { name: "Multi", hex: "#c49a60", image: "/images/products/product-5.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9],
    description: "Patchwork z resztek skóry. Zero waste, każda para jedyna w swoim rodzaju.",
    features: ["Patchwork leather", "Zero waste", "One of a kind"],
    materials: "Skóra naturalna - resztki produkcyjne.",
    care: "Czyścić miękką szmatką.",
    images: ["/images/products/product-5.jpg", "/images/products/product-12.jpg"],
  },
  {
    id: "89",
    name: "Wełniane Kapcie",
    slug: "welniane-kapcie",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "all"],
    price: 99,
    type: "slip-on",
    material: "wool",
    rating: 4.4,
    reviewCount: 12,
    tags: ["handmade", "slippers", "wool", "cozy"],
    sellerId: "s8",
    colors: [
      { name: "Grey", hex: "#9a9a9a", image: "/images/products/product-8.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11],
    description: "Filcowane kapcie z wełny. Ciepłe, lekkie, idealne na zimowe wieczory.",
    features: ["Felted wool", "Leather sole", "Handmade"],
    materials: "Wełna owcza filcowana, podeszwa skórzana.",
    care: "Czyścić na sucho.",
    images: ["/images/products/product-8.jpg"],
  },
  {
    id: "90",
    name: "Haftowane Espadryle",
    slug: "haftowane-espadryle",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "all"],
    price: 139,
    type: "slip-on",
    material: "tree-fiber",
    rating: 4.0,
    reviewCount: 4,
    tags: ["handmade", "embroidered", "summer", "espadrille"],
    sellerId: "s8",
    colors: [
      { name: "Natural", hex: "#c4b59a", image: "/images/products/product-15.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9],
    description: "Espadryle z ręcznym haftem. Jutowy spód, bawełniana cholewka, kwiatowy wzór.",
    features: ["Hand embroidered", "Jute sole", "Cotton upper"],
    materials: "Bawełna, juta.",
    care: "Czyścić delikatnie. Nie prać w pralce.",
    images: ["/images/products/product-15.jpg"],
  },

  // ── VintageFind (s9) - Secondhand/vintage vibe items ──
  {
    id: "91",
    name: "Retro Runner '88",
    slug: "retro-runner-88",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 149,
    type: "runner",
    material: "mesh",
    rating: 4.0,
    reviewCount: 11,
    tags: ["vintage", "retro", "runner", "80s"],
    sellerId: "s9",
    colors: [
      { name: "Off White/Blue", hex: "#e8e0d4", image: "/images/products/product-9.jpg" },
    ],
    sizes: [8, 9, 10, 11],
    description: "Vintage-style runner with 80s color blocking. Intentionally aged look, modern comfort.",
    features: ["Vintage styling", "Gum sole", "Padded collar"],
    materials: "Upper: Nylon/suede. Sole: Gum rubber.",
    care: "Spot clean only.",
    images: ["/images/products/product-9.jpg"],
  },
  {
    id: "92",
    name: "Washed Canvas Hi",
    slug: "washed-canvas-hi",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "all"],
    price: 119,
    type: "trainer",
    material: "tree-fiber",
    rating: 3.9,
    reviewCount: 7,
    tags: ["vintage", "canvas", "high-top", "washed"],
    sellerId: "s9",
    colors: [
      { name: "Washed Black", hex: "#3a3a3a", image: "/images/products/product-1.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11, 12],
    description: "High-top canvas sneaker with a washed, broken-in finish. Looks like you've owned them for years.",
    features: ["Washed canvas", "Vulcanized sole", "High-top"],
    materials: "Canvas, rubber.",
    care: "Spot clean.",
    images: ["/images/products/product-1.jpg", "/images/products/product-16.jpg"],
  },
  {
    id: "93",
    name: "Vintage Loafer",
    slug: "vintage-loafer",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "all"],
    price: 169,
    type: "loafer",
    material: "leather",
    rating: 4.1,
    reviewCount: 9,
    tags: ["vintage", "loafer", "leather", "classic"],
    sellerId: "s9",
    colors: [
      { name: "Aged Brown", hex: "#6b4a3a", image: "/images/products/product-4.jpg" },
    ],
    sizes: [8, 9, 10, 11],
    description: "Vintage-style penny loafer with an aged leather finish. Has that broken-in look from day one.",
    features: ["Aged leather", "Leather sole", "Penny slot"],
    materials: "Leather, antiqued finish.",
    care: "Condition occasionally.",
    images: ["/images/products/product-4.jpg"],
  },
  {
    id: "94",
    name: "Retro Trainer",
    slug: "retro-trainer",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "all"],
    price: 139,
    type: "trainer",
    material: "leather",
    rating: 4.0,
    reviewCount: 6,
    tags: ["vintage", "retro", "trainer", "90s"],
    sellerId: "s9",
    colors: [
      { name: "White/Green", hex: "#f0ede6", image: "/images/products/product-2.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9],
    description: "90s-inspired trainer with a chunky sole and color pop accents. Vintage vibes, new construction.",
    features: ["Chunky sole", "Color accents", "Padded collar"],
    materials: "Upper: PU leather. Sole: Rubber.",
    care: "Wipe clean.",
    images: ["/images/products/product-2.jpg", "/images/products/product-11.jpg"],
  },
  {
    id: "95",
    name: "Distressed Slip-On",
    slug: "distressed-slip-on",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "all"],
    price: 99,
    type: "slip-on",
    material: "tree-fiber",
    rating: 3.8,
    reviewCount: 4,
    tags: ["vintage", "distressed", "canvas", "casual"],
    sellerId: "s9",
    colors: [
      { name: "Washed Cream", hex: "#e8e0d4", image: "/images/products/product-8.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11],
    description: "Distressed canvas slip-on. Intentionally imperfect, effortlessly cool.",
    features: ["Distressed canvas", "Elastic gusset", "Vulcanized sole"],
    materials: "Canvas, rubber.",
    care: "Spot clean.",
    images: ["/images/products/product-8.jpg"],
  },

  // ── DropStyle (s10) - Budget items ──
  {
    id: "96",
    name: "Basic Runner",
    slug: "basic-runner-drop",
    category: "men",
    productCategory: "shoes",
    collections: ["mens", "sale", "all"],
    price: 79,
    type: "runner",
    material: "mesh",
    rating: 3.8,
    reviewCount: 23,
    tags: ["budget", "lightweight", "everyday"],
    sellerId: "s10",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
      { name: "White", hex: "#f0ede6", image: "/images/products/product-9.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11, 12],
    description: "Cheap runner that does the job. Nothing fancy.",
    features: ["Mesh upper", "Foam sole", "Lightweight"],
    materials: "Polyester mesh, EVA foam.",
    care: "Machine wash.",
    badge: "sale",
    images: ["/images/products/product-1.jpg"],
  },
  {
    id: "97",
    name: "Drop Tee",
    slug: "drop-tee",
    category: "unisex",
    productCategory: "apparel",
    collections: ["mens", "womens", "apparel", "sale", "all"],
    price: 49,
    type: "tee",
    material: "tree-fiber",
    rating: 3.7,
    reviewCount: 45,
    tags: ["budget", "basic", "everyday"],
    sellerId: "s10",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-17.jpg" },
      { name: "White", hex: "#f0ede6", image: "/images/products/product-18.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Basic tee at a basic price. Cotton blend, regular fit.",
    features: ["Regular fit", "Crew neck"],
    materials: "Cotton/polyester blend.",
    care: "Machine wash.",
    images: ["/images/products/product-17.jpg"],
  },
  {
    id: "98",
    name: "Drop Runner W",
    slug: "drop-runner-womens",
    category: "women",
    productCategory: "shoes",
    collections: ["womens", "sale", "all"],
    price: 79,
    type: "runner",
    material: "mesh",
    rating: 3.6,
    reviewCount: 15,
    tags: ["budget", "lightweight", "everyday"],
    sellerId: "s10",
    colors: [
      { name: "Pink", hex: "#d4a5a5", image: "/images/products/product-12.jpg" },
    ],
    sizes: [5, 6, 7, 8, 9],
    description: "Budget runner for everyday. Gets the job done.",
    features: ["Mesh upper", "Foam sole"],
    materials: "Polyester mesh, EVA foam.",
    care: "Machine wash.",
    badge: "sale",
    images: ["/images/products/product-12.jpg"],
  },
  {
    id: "99",
    name: "Drop Slide",
    slug: "drop-slide",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "sale", "all"],
    price: 49,
    type: "slide",
    material: "mesh",
    rating: 3.5,
    reviewCount: 31,
    tags: ["budget", "casual", "easy-on"],
    sellerId: "s10",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-16.jpg" },
    ],
    sizes: [6, 7, 8, 9, 10, 11],
    description: "Cheap slide. Foam sole, nylon strap. Beach, shower, whatever.",
    features: ["Foam sole", "Nylon strap"],
    materials: "EVA foam, nylon.",
    care: "Rinse with water.",
    images: ["/images/products/product-16.jpg"],
  },
  {
    id: "100",
    name: "Drop Hoodie",
    slug: "drop-hoodie",
    category: "unisex",
    productCategory: "apparel",
    collections: ["mens", "womens", "apparel", "sale", "all"],
    price: 89,
    type: "hoodie",
    material: "knit",
    rating: 3.9,
    reviewCount: 19,
    tags: ["budget", "warm", "everyday"],
    sellerId: "s10",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-20.jpg" },
      { name: "Grey", hex: "#8a8a8a", image: "/images/products/product-21.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Budget hoodie. Fleece lined, kangaroo pocket. Does what it needs to.",
    features: ["Fleece lined", "Kangaroo pocket", "Drawcord hood"],
    materials: "Cotton/polyester blend.",
    care: "Machine wash.",
    images: ["/images/products/product-20.jpg"],
  },

  // ── Kasia Creates (s11) - Accessories only ──
  {
    id: "31",
    name: "Tote Bag",
    slug: "tote-bag",
    category: "unisex",
    productCategory: "accessories",
    collections: ["mens", "womens", "accessories", "new-arrivals", "all"],
    price: 139,
    type: "bag",
    material: "tree-fiber",
    rating: 4.3,
    reviewCount: 156,
    tags: ["everyday", "spacious", "sustainable", "lightweight"],
    sellerId: "s11",
    colors: [
      { name: "Natural", hex: "#c4b59a", image: "/images/products/product-28.jpg" },
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-29.jpg" },
    ],
    sizes: [0],
    description: "Handcrafted tote from tree-fiber canvas. Holds everything, weighs almost nothing.",
    features: ["Tree-fiber canvas", "Interior pocket", "Reinforced handles", "Machine washable"],
    materials: "100% Eucalyptus tree fiber canvas.",
    care: "Machine wash cold. Air dry.",
    badge: "new",
    images: ["/images/products/product-28.jpg", "/images/products/product-29.jpg"],
  },
  {
    id: "32",
    name: "Beanie",
    slug: "beanie",
    category: "unisex",
    productCategory: "accessories",
    collections: ["mens", "womens", "accessories", "all"],
    price: 109,
    type: "beanie",
    material: "wool",
    rating: 4.6,
    reviewCount: 203,
    tags: ["warm", "cozy", "winter", "sustainable"],
    sellerId: "s11",
    colors: [
      { name: "Charcoal", hex: "#333333", image: "/images/products/product-30.jpg" },
      { name: "Cream", hex: "#f0ede6", image: "/images/products/product-31.jpg" },
      { name: "Navy", hex: "#2a3a5c", image: "/images/products/product-30.jpg" },
    ],
    sizes: [0],
    description: "Handmade merino wool beanie. Warm without the itch.",
    features: ["Merino wool knit", "Double-layered", "Ribbed cuff", "One size fits most"],
    materials: "100% ZQ Merino wool.",
    care: "Hand wash cold. Lay flat to dry.",
    images: ["/images/products/product-30.jpg", "/images/products/product-31.jpg"],
  },
  {
    id: "33",
    name: "Cap",
    slug: "cap",
    category: "unisex",
    productCategory: "accessories",
    collections: ["mens", "womens", "accessories", "all"],
    price: 129,
    type: "cap",
    material: "mesh",
    rating: 4.2,
    reviewCount: 89,
    tags: ["breathable", "adjustable", "casual", "sun-protection"],
    sellerId: "s11",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-30.jpg" },
      { name: "Olive", hex: "#5c6b4f", image: "/images/products/product-31.jpg" },
    ],
    sizes: [0],
    description: "Breathable mesh-backed cap with an adjustable strap. Made from recycled materials.",
    features: ["Recycled mesh back", "Adjustable snapback", "Curved brim", "Moisture-wicking sweatband"],
    materials: "Front: Recycled polyester. Back: Recycled mesh.",
    care: "Spot clean with damp cloth.",
    images: ["/images/products/product-30.jpg", "/images/products/product-31.jpg"],
  },
  {
    id: "101",
    name: "Crossbody Bag",
    slug: "crossbody-bag",
    category: "unisex",
    productCategory: "accessories",
    collections: ["mens", "womens", "accessories", "all"],
    price: 119,
    type: "bag",
    material: "tree-fiber",
    rating: 4.1,
    reviewCount: 34,
    tags: ["crossbody", "compact", "everyday", "handcrafted"],
    sellerId: "s11",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-28.jpg" },
      { name: "Tan", hex: "#c4a060", image: "/images/products/product-29.jpg" },
    ],
    sizes: [0],
    description: "Compact crossbody bag. Fits phone, wallet, keys. Adjustable strap.",
    features: ["Adjustable strap", "Zip closure", "Interior pocket"],
    materials: "Organic cotton canvas.",
    care: "Spot clean.",
    images: ["/images/products/product-28.jpg"],
  },

  // ── FirstStep (s12) - Basic items ──
  {
    id: "34",
    name: "Insole Replacement",
    slug: "insole-replacement",
    category: "unisex",
    productCategory: "accessories",
    collections: ["mens", "womens", "accessories", "all"],
    price: 59,
    type: "insole",
    material: "tree-fiber",
    rating: 4.0,
    reviewCount: 45,
    tags: ["comfort", "replacement", "cushioned", "odor-resistant"],
    sellerId: "s12",
    colors: [
      { name: "Natural", hex: "#c4b59a", image: "/images/products/product-8.jpg" },
    ],
    sizes: [0],
    description: "Replacement insoles. Castor bean oil foam topped with tree-fiber.",
    features: ["Castor bean foam base", "Tree-fiber top cloth", "Odor-resistant"],
    materials: "Base: Castor bean oil foam. Top: Eucalyptus tree fiber.",
    care: "Remove from shoe and air dry regularly.",
    images: ["/images/products/product-8.jpg"],
  },
  {
    id: "102",
    name: "First Runner",
    slug: "first-runner",
    category: "unisex",
    productCategory: "shoes",
    collections: ["mens", "womens", "all"],
    price: 99,
    type: "runner",
    material: "mesh",
    rating: 0,
    reviewCount: 0,
    tags: ["basic", "everyday", "budget"],
    sellerId: "s12",
    colors: [
      { name: "Black", hex: "#1a1a1a", image: "/images/products/product-1.jpg" },
    ],
    sizes: [7, 8, 9, 10, 11],
    description: "Basic runner. Our first product. Simple mesh upper, foam sole.",
    features: ["Mesh upper", "Foam midsole"],
    materials: "Polyester mesh, EVA foam.",
    care: "Machine wash cold.",
    images: ["/images/products/product-1.jpg"],
  },
  {
    id: "103",
    name: "First Tee",
    slug: "first-tee",
    category: "unisex",
    productCategory: "apparel",
    collections: ["mens", "womens", "apparel", "all"],
    price: 59,
    type: "tee",
    material: "tree-fiber",
    rating: 0,
    reviewCount: 0,
    tags: ["basic", "everyday"],
    sellerId: "s12",
    colors: [
      { name: "White", hex: "#f0ede6", image: "/images/products/product-17.jpg" },
    ],
    sizes: [1, 2, 3, 4],
    description: "Simple cotton tee. Nothing fancy, just a tee.",
    features: ["Cotton fabric", "Regular fit"],
    materials: "100% Cotton.",
    care: "Machine wash.",
    images: ["/images/products/product-17.jpg"],
  },
];

export function getProduct(slug: string): Product | undefined {
  return products.find((p) => p.slug === slug);
}

export function getProductsByCollection(collectionSlug: string): Product[] {
  const categoryMap: Record<string, string> = {
    socks: "socks",
    apparel: "apparel",
    accessories: "accessories",
  };

  if (collectionSlug === "all") {
    return products;
  }

  const productCat = categoryMap[collectionSlug];
  if (productCat) {
    return products.filter((p) => p.productCategory === productCat);
  }

  return products.filter((p) => p.collections.includes(collectionSlug));
}

export function getRelatedProducts(product: Product, limit = 8): Product[] {
  return products
    .filter(
      (p) =>
        p.id !== product.id &&
        (p.category === product.category ||
          p.collections.some((c) => product.collections.includes(c)))
    )
    .slice(0, limit);
}

export function getProductsBySeller(sellerSlug: string): Product[] {
  const seller = getSeller(sellerSlug);
  if (!seller) return [];
  return products.filter((p) => p.sellerId === seller.id);
}

export const heroSlides: HeroSlide[] = [
  {
    id: "1",
    subtitle: "OUR LABEL + 4,000 SELLERS",
    title: "Our Craft. Your Style.",
    image: "/images/hero/hero-1.jpg",
    ctaLinks: [
      { label: "SHOP MEN", href: "/collections/mens" },
      { label: "SHOP WOMEN", href: "/collections/womens" },
    ],
  },
  {
    id: "2",
    subtitle: "NEW ON FASHIONHERO",
    title: "Fresh brands. Unique finds.",
    image: "/images/hero/hero-2.jpg",
    ctaLinks: [
      { label: "SHOP NEW ARRIVALS", href: "/collections/new-arrivals" },
    ],
  },
  {
    id: "3",
    subtitle: "FASHION MARKETPLACE",
    title: "From indie designers to top brands. All in one place.",
    image: "/images/hero/hero-3.jpg",
    ctaLinks: [
      { label: "EXPLORE ALL", href: "/collections/all" },
    ],
  },
];
